import React, { useState, useEffect } from "react";
import SideMenu from "./SideMenu";


import Swal from 'sweetalert2';
import { useNavigate, Link, useParams } from "react-router-dom"
import db from "./Firebase";
import axios from "axios";
// import { firebase, auth } from './FirebaseLogin';
import { arrayUnion, arrayRemove } from "firebase/firestore";
import { collection, query, orderBy, onSnapshot, doc, updateDoc } from "firebase/firestore";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { CSVLink } from "react-csv";
// const fileInputRef = useRef(null);
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const RowItem = ({ label, value }) => (
    <div style={styles.rowItem}>
        <span style={styles.label}>{label}</span>
        <span style={styles.value}>{value ?? "-"}</span>
    </div>
);

const SectionCard = ({ title, children, right }) => (
    <div style={styles.card}>
        <div style={styles.cardHeader}>
            <h4 style={{ margin: 0, fontSize: 18 }}>{title}</h4>
            {right}
        </div>
        <div style={{ padding: 16 }}>{children}</div>
    </div>
);

const DocThumb = ({ src, title, onClick }) => (
    <div style={styles.docThumb} onClick={() => onClick(src, title)} title={title}>
        <img src={src} alt={title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <div style={styles.docCaption}>{title}</div>
    </div>
);


const DocThumbPDF = ({ src, title, onClick }) => {
    return (
        <div
            style={styles.docThumb}
            onClick={() => window.open(src, "_blank")}
            title={title}
        >

            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
                <img src="https://www.iconpacks.net/icons/2/free-pdf-file-icon-3382-thumb.png" alt="bruce" class="w-50 shadow-sm" />
                <div style={{ marginTop: 8, fontSize: 12 }}>{title}</div>
            </div>

        </div>
    );
};



const DocThumbVideo = ({ src, title, onClick }) => {
    return (
        <a href={src} download target="_blank">
            {/* <div
                style={styles.docThumb}

                title={title}
            >

                <div style={styles.centerContent}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png" alt="bruce" class="w-50 shadow-sm" />
                    <span class="badge badge-success ms-auto mb-auto">Download</span>
                </div>

            </div> */}
            <div
                style={styles.docThumb}
                onClick={() => window.open(src, "_blank")}
                title={title}
            >

                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%" }}>
                    <img src="https://png.pngtree.com/element_our/20190528/ourmid/pngtree-video-icon-image_1128393.jpg" alt="bruce" class="w-50 shadow-sm" />
                    <div style={{ marginTop: 8, fontSize: 12 }}>{title}</div>
                </div>

            </div>
        </a>
    );
};



const TabButton = ({ active, children, onClick }) => (
    <button
        onClick={onClick}
        style={{
            ...styles.tabBtn,
            ...(active ? styles.tabBtnActive : {})
        }}
    >
        {children}
    </button>
);


function UsersLoanDetails() {
    let params = useParams();
    const [fileKey, setFileKey] = useState(0);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true)
    const [personalData, setPersonalData] = useState({});
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [uid, setUid] = useState('');
    const [logs, setLogs] = useState([]);
    const [remarks, setRemarks] = useState([]);
    const [slots, setSlots] = useState({});
    const [slotsID, setSlotsID] = useState({});
    const [csvdata, setCsvdata] = useState([]);
    const [selectedSlots, setSelectedSlots] = useState([]);
    const [email, setEmail] = useState('');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [repaymentHistory, setRepaymentHistory] = useState([]);


    const [editIndex, setEditIndex] = useState(null);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    useEffect(() => {
        const storedEmail = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");
        setEmail(storedEmail);

        if (storedRemember === "false" || !storedEmail || !storedPassword) {
            navigate('/signin');
        }

    }, []);


    const headers = [
        { label: "Applicant Name", key: "applicant_name" },
        { label: "Applicant Name", key: "applicant_phone" },
        { label: "loan_id", key: "loan_id" },
        { label: "applicant_date_of_birth", key: "applicant_date_of_birth" },
        { label: "loan_type", key: "loan_type" },
        { label: "gender", key: "gender" },
        { label: "applicant_alternate_phone", key: "applicant_alternate_phone" },
        { label: "applicant_marital_status", key: "applicant_marital_status" },
        { label: "fathers_name", key: "fathers_name" },
        { label: "mothers_name", key: "mothers_name" },
        { label: "city", key: "city" },
        { label: "state", key: "state" },
        { label: "pincode", key: "pincode" },
        { label: "full_address", key: "full_address" },
        { label: "highest_education", key: "highest_education" },
        { label: "business_type", key: "business_type" },
        { label: "parlour_freelancer_name", key: "parlour_freelancer_name" },
        { label: "parlour_address", key: "parlour_address" },
        { label: "ownership_type", key: "ownership_type" },
        { label: "working_since", key: "working_since" },
        { label: "monthly_since", key: "monthly_since" },
        { label: "bank_account_number", key: "bank_account_number" },
        { label: "bank_name", key: "bank_name" },
        { label: "ifsc_code", key: "ifsc_code" },
        { label: "upi_id", key: "upi_id" },
        { label: "loan_amount", key: "loan_amount" },
        { label: "have_you_taken_loan_in_past", key: "have_you_taken_loan_in_past" },
        { label: "needGrant", key: "needGrant" },
        { label: "purposeOfReason", key: "purposeOfReason" },
        { label: "reasonEstimated", key: "reasonEstimated" },
        { label: "repaymentModel", key: "repaymentModel" },
        { label: "how_did_you_know_about_scheme", key: "how_did_you_know_about_scheme" },
        { label: "aadhar_front", key: "aadhar_front" },
        { label: "aadhar_back", key: "aadhar_back" },
        { label: "pan", key: "pan" },
        { label: "passbook", key: "passbook" },
        { label: "parlour_photo", key: "parlour_photo" },
        { label: "applicant_photo", key: "applicant_photo" },
        { label: "error_message", key: "error_message" },
        { label: "document_status", key: "document_status" },
        { label: "document_status_done_msg", key: "document_status_done_msg" },
        { label: "document_status_pending_msg", key: "document_status_pending_msg" },
        { label: "verification_status", key: "verification_status" },
        { label: "verification_status_done_msg", key: "verification_status_done_msg" },
        { label: "verification_status_pending_msg", key: "verification_status_pending_msg" },
        { label: "nbfc_status", key: "nbfc_status" },
        { label: "nbfc_status_done_msg", key: "nbfc_status_done_msg" },
        { label: "nbfc_status_pending_msg", key: "nbfc_status_pending_msg" },
        { label: "penny_check_status", key: "penny_check_status" },
        { label: "penny_check_status_done_msg", key: "penny_check_status_done_msg" },
        { label: "penny_check_status_pending_msg", key: "penny_check_status_pending_msg" },
        { label: "godrej_status", key: "godrej_status" },
        { label: "godrej_status_done_msg", key: "godrej_status_done_msg" },
        { label: "godrej_status_pending_msg", key: "godrej_status_pending_msg" },
        { label: "loan_disbursement_status", key: "loan_disbursement_status" },
        { label: "loan_disbursement_status_done_msg", key: "loan_disbursement_status_done_msg" },
        { label: "loan_disbursement_status_pending_msg", key: "loan_disbursement_status_pending_msg" },
        { label: "custom_msg_one", key: "custom_msg_one" },
        { label: "custom_msg_two", key: "custom_msg_two" },
        { label: "status", key: "status" },
        { label: "created_date", key: "created_date", dataFormat: "MM/DD/YY, h:mm a" },
        { label: "updated_date", key: "updated_date", dataFormat: "MM/DD/YY, h:mm a" },
    ];

    const handleSlotSelection = (slot) => {
        if (selectedSlots.length === 2) {
            if (selectedSlots.includes(slot)) {
                setSelectedSlots(selectedSlots.filter((selectedSlot) => selectedSlot !== slot));
            } else {

                alert("You can only select two slots")
            }
        } else {
            if (selectedSlots.includes(slot)) {
                setSelectedSlots(selectedSlots.filter((selectedSlot) => selectedSlot !== slot));
            } else {
                setSelectedSlots([...selectedSlots, slot]);
            }
        }

    };

    const timeSlots = ['9:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '1:00 PM', '2:00 PM', '3:00 PM', '4:00 PM', '5:00 PM', '6:00 PM',];


    const emiPlans = {
        1: "₹4000 For 5 Months",
        2: "₹5000 For 4 Months",
        3: "₹1000 For 10 Months",
        4: "₹2500 For 4 Months",
        5: "₹1250 For 8 Months",
        6: "₹3750 For 4 Months",
        7: "₹3000 For 5 Months",
        8: "₹5000 For 5 Months",
        9: "₹3125 For 8 Months",
    };


    const emiPlansList = {
        1: "20000",
        2: "20000",
        3: "10000",
        4: "10000",
        5: "10000",
        6: "15000",
        7: "15000",
        8: "25000",
        9: "25000",
    };




    const whatsappDocRejected = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_loan_rejected",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const whatsappDocDone = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_doc_verification",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const whatsappVideoDone = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_vdo_verification",
                "language": {
                    "code": "en",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const whatsappVideoRejected = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_vdo_rejected",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const whatsappPhyDone = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_physical_verification",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }


    const whatsappPhyRejected = (phone, name) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_physical_rejected",
                "language": {
                    "code": "en",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }

    const whatsappLoanDisbursed = (phone, name, amount) => {

        var myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer EABMKlZCrATXIBAPOZBZBPqsdfot34fq0FTipZBQf3RiXZAapyCOqMay09HfhSxoB8bd5ZA7RUnLWhd0JkXtACJQ682THiDEMhQhyPOkeui8Cb8P72WPDhihUZBCkHtPLSgsmuZA6iRY6VunDDIjPA5mATQQITVXOECHqkZB5E2pzWSC2AaUp0wZCWR");
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "messaging_product": "whatsapp",
            "to": `91${phone}`,
            "type": "template",
            "template": {
                "name": "finance_loan_disbursed",
                "language": {
                    "code": "en_US",
                    "policy": "deterministic"
                },
                "components": [
                    {
                        "type": "body",
                        "parameters": [
                            {
                                "type": "text",
                                "text": name
                            },
                            {
                                "type": "text",
                                "text": amount
                            }
                        ]
                    }
                ]
            }
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch("https://graph.facebook.com/v14.0/104489945783566/messages", requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));

    }









    const openModalNew = () => {
        window.openModelNew();
    }

    const handleIsCompleteChange = async (index, newValue, name, phone) => {
        console.log(index)
        console.log(newValue)
        if (index == 0 && newValue == "true") {
            whatsappDocDone(phone, name)
        }
        if (index == 1 && newValue == "true") {
            whatsappVideoDone(phone, name)
        }
        if (index == 2 && newValue == "true") {
            whatsappPhyDone(phone, name)
        }
        try {
            // Clone existing progress array
            const updatedProgress = [...personalData.progress];
            updatedProgress[index].isComplete = newValue === "true"; // Convert string to boolean
            // updatedProgress[index].date = moment().format("DD-MM-YYYY"); // Set current date

            // Update Firestore
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, { progress: updatedProgress });

            // Update UI Instantly
            setPersonalData((prevData) => ({
                ...prevData,
                progress: updatedProgress,
            }));
        } catch (error) {
            console.error("Error updating isComplete:", error);
            Swal.fire("Error!", "Failed to update completion status.", "error");
        }
    };

    const [formDataFinal, setFormDataFinal] = useState({
        approvedAmount: "",
        transactionId: "",
        selectedEmiPlan: "",
        // numberOfInstallments: "",

    });


    const handleChangeFinalDetails = (e) => {
        const { name, value } = e.target;

        const updatedValue = name === "selectedEmiPlan" ? parseInt(value) : value;

        setFormDataFinal((prev) => {
            const updatedForm = {
                ...prev,
                [name]: updatedValue,
            };

            // If selectedEmiPlan is being updated, update approvedAmount too
            if (name === "selectedEmiPlan") {
                updatedForm.approvedAmount = emiPlansList[updatedValue];
            }


            return updatedForm;
        });
    };





    const handleSubmitFinal = async (e) => {
        e.preventDefault();
        console.log(personalData.username);
        console.log(personalData.fullName);
        console.log(personalData.loanAmount);
        console.log("Submitted Loan Form Data:", formDataFinal);
        console.log(parseInt(formDataFinal.selectedEmiPlan));
        console.log(emiPlansList[parseInt(formDataFinal.selectedEmiPlan)]);


        whatsappLoanDisbursed(personalData.username, personalData.fullName, formDataFinal.approvedAmount);


        try {
            // Determine the new status value based on final_status
            // const newStatusValue = newStatus === "Disbursed" ? 1 : 0;

            // Update Firestore with the new final_status & status
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, {
                final_status: "Disbursed", status: 1, txn_id: formDataFinal.transactionId, loanAmount: formDataFinal.approvedAmount, selected_emi_plan: formDataFinal.selectedEmiPlan, 'updated_date': new Date(), 'loan_disbursement_date': new Date(), repayment_completed: 0,
            });



            // Update UI Instantly
            setPersonalData((prevData) => ({
                ...prevData,
                final_status: "Disbursed",
                status: 1, // Ensure UI reflects the change
            }));
            createPaymentHistory(formDataFinal.selectedEmiPlan);
        } catch (error) {
            console.error("Error updating final_status:", error);
            Swal.fire("Error!", "Failed to update final status.", "error");
        }
    };


    // 🔥 Handle Status Change in Table & Update Firestore
    const handleStatusChange = async (index, newStatus, name, phone) => {

        console.log(index);
        console.log(newStatus);
        console.log(name);
        console.log(phone);
        if (index == 0 && newStatus == "Done") {
            whatsappDocDone(phone, name)

        }
        if (index == 0 && newStatus == "Rejected") {
            whatsappDocRejected(phone, name)
        }

        if (index == 1 && newStatus == "Done") {
            whatsappVideoDone(phone, name)

        }
        if (index == 1 && newStatus == "Rejected") {
            whatsappVideoRejected(phone, name)
        }


        if (index == 2 && newStatus == "Done") {
            whatsappPhyDone(phone, name)

        }
        if (index == 2 && newStatus == "Rejected") {
            whatsappPhyRejected(phone, name)
        }

        if (index == 4 && newStatus == "Done") {
            whatsappLoanDisbursed(phone, name)

        }


        if (newStatus == "Done") {
            handleIsCompleteChange(index, "true", personalData.fullName, personalData.username)
        } else {
            handleIsCompleteChange(index, "false", personalData.fullName, personalData.username)
        }

        // console.log(index)
        // console.log(newStatus)
        // console.log(name)
        // console.log(phone)
        // if (index == 0 && newStatus == "Rejected") {
        //     whatsappDocRejected(phone, name)
        // }
        // if (index == 1 && newStatus == "Rejected") {
        //     whatsappVideoRejected(phone, name)
        // }
        // if (index == 2 && newStatus == "Rejected") {
        //     whatsappPhyRejected(phone, name)
        // }
        try {
            // Clone existing progress array
            const updatedProgress = [...personalData.progress];
            updatedProgress[index].status = newStatus;
            // updatedProgress[index].date = moment().format("DD-MM-YYYY");

            // Update Firestore
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, { progress: updatedProgress });

            // Update UI Instantly
            setPersonalData((prevData) => ({
                ...prevData,
                progress: updatedProgress,
            }));
        } catch (error) {
            console.error("Error updating status:", error);
            Swal.fire("Error!", "Failed to update status.", "error");
        }
    };

    // const handleMessageChangeDateNew = async (index) => {
    //     const { value: date } = await Swal.fire({
    //         title: "select departure date",
    //         input: "date",
    //         didOpen: () => {
    //             const today = (new Date()).toISOString();
    //             Swal.getInput().min = today.split("T")[0];
    //         }
    //     });
    //     if (date) {
    //         Swal.fire("Departure date", date);
    //     }
    // }

    const handleMessageChangeDateNew = async (index) => {
        const { isConfirmed } = await Swal.fire({
            title: "Select Date",
            html: `
            <input type="date" id="swal-date" class="swal2-input" />
        `,
            focusConfirm: false,
            preConfirm: () => {
                const input = document.getElementById("swal-date");
                return input.value;
            },
            showCancelButton: true,
            confirmButtonText: "Save",
        });

        const selectedDate = document.getElementById("swal-date")?.value;

        if (isConfirmed && selectedDate) {
            try {
                const formatted = moment(selectedDate, "YYYY-MM-DD").format("DD-MM-YYYY");
                const updatedProgress = [...personalData.progress];
                updatedProgress[index].date = formatted;

                const docRef = doc(db, "nv_loan", uid);
                await updateDoc(docRef, { progress: updatedProgress });

                setPersonalData((prevData) => ({
                    ...prevData,
                    progress: updatedProgress,
                }));

                Swal.fire("✅ Updated!", `Date set to ${formatted}`, "success");
            } catch (error) {
                console.error("Error updating date:", error);
                Swal.fire("❌ Error!", "Failed to update date.", "error");
            }
        }
    };



    const handleMessageChangeDate = async (index, date) => {
        console.log(index);
        console.log(date);
        try {
            const formatted = moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
            const updatedProgress = [...personalData.progress];
            updatedProgress[index].date = formatted;
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, { progress: updatedProgress });

            setPersonalData((prevData) => ({
                ...prevData,
                progress: updatedProgress,
            }));
        } catch (error) {
            console.error("Error updating date:", error);
            Swal.fire("Error!", "Failed to update date.", "error");
        }
    }

    // 🔥 Handle Message Change in Table & Update Firestore
    const handleMessageChange = async (index, newMessage) => {
        try {
            // Clone existing progress array
            const updatedProgress = [...personalData.progress];
            updatedProgress[index].message = newMessage;
            // updatedProgress[index].date = moment().format("DD-MM-YYYY");

            // Update Firestore
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, { progress: updatedProgress });

            // Update UI Instantly
            setPersonalData((prevData) => ({
                ...prevData,
                progress: updatedProgress,
            }));
        } catch (error) {
            console.error("Error updating message:", error);
            Swal.fire("Error!", "Failed to update message.", "error");
        }
    };

    // const handleDateChangeDisbursement = async (index, date) => {
    //     try {
    //         const formatted = moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");

    //         const updatedProgress = [...personalData.progress];
    //         updatedProgress[index].date = formatted;

    //         const docRef = doc(db, "nv_loan", uid);
    //         await updateDoc(docRef, { progress: updatedProgress, final_status: "Pending" });

    //         setPersonalData((prevData) => ({
    //             ...prevData,
    //             progress: updatedProgress,
    //         }));
    //     } catch (error) {
    //         console.error("Error updating date:", error);
    //         Swal.fire("Error!", "Failed to update date.", "error");
    //     }
    // };


    const handleDateChangeDisbursement = async (index) => {
        const { isConfirmed } = await Swal.fire({
            title: "Select Disburse Date",
            html: `
            <input type="date" id="swal-date" class="swal2-input" />
        `,
            focusConfirm: false,
            preConfirm: () => {
                const input = document.getElementById("swal-date");
                return input.value;
            },
            showCancelButton: true,
            confirmButtonText: "Save",
        });

        const selectedDate = document.getElementById("swal-date")?.value;

        if (isConfirmed && selectedDate) {
            try {
                const formatted = moment(selectedDate, "YYYY-MM-DD").format("DD-MM-YYYY");
                const updatedProgress = [...personalData.progress];
                updatedProgress[index].date = formatted;

                const docRef = doc(db, "nv_loan", uid);
                await updateDoc(docRef, { progress: updatedProgress, final_status: "Pending" });


                setPersonalData((prevData) => ({
                    ...prevData,
                    progress: updatedProgress,
                }));

                Swal.fire("✅ Updated!", `Date set to ${formatted}`, "success");
            } catch (error) {
                console.error("Error updating date:", error);
                Swal.fire("❌ Error!", "Failed to update date.", "error");
            }
        }
    };




    const handleFinalStatusChange = async (newStatus, phone, name, amount) => {
        console.log(newStatus)
        if (newStatus == "Disbursed") {
            whatsappLoanDisbursed(phone, name, amount);
        }
        try {
            // Determine the new status value based on final_status
            const newStatusValue = newStatus === "Disbursed" ? 1 : 0;

            // Update Firestore with the new final_status & status
            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, {
                final_status: newStatus, status: newStatusValue, 'updated_date': new Date(), 'loan_disbursement_date': new Date(), repayment_completed: 0,
            });



            // Update UI Instantly
            setPersonalData((prevData) => ({
                ...prevData,
                final_status: newStatus,
                status: newStatusValue, // Ensure UI reflects the change
            }));
        } catch (error) {
            console.error("Error updating final_status:", error);
            Swal.fire("Error!", "Failed to update final status.", "error");
        }
    };




    useEffect(() => {
        db.collection("loan_logs").where('phone', '==', params.id).orderBy("updated_date", "desc").onSnapshot((snapshot) => {
            setLogs(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );

        });

        db.collection("loan_extra_data").where('phone', '==', params.id).onSnapshot((snapshot) => {
            setRemarks(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );

        });


        db.collection("time_slot").where('phone', '==', params.id).onSnapshot((snapshot) => {
            snapshot.docs.map(e => { setSlots(e.data()) })
            setSlotsID(snapshot.docs.map((doc) => ({
                id: doc.id,
            })))
            // console.log("---------");
            // console.log(slots?.selected_time);
            // setSlots(
            //     snapshot.docs.map((doc) => ({
            //         id: doc.id,
            //         data: doc.data(),
            //     }))
            // );
        });
        // db.collection("loan").where('username', '==', params.id.toLowerCase()).onSnapshot((snapshot) => {
        // db.collection("nv_loan").where('username', '==', params.id).onSnapshot((snapshot) => {
        //     snapshot.docs.map(e => setPersonalData(e.data()))
        //     // alert(snapshot.docs)
        //     setUid(snapshot.docs[0].id)
        //     setRepaymentHistory(data.payment_history || []);
        //     if (snapshot.docs.length == 0) {
        //         navigate('/error');
        //     } else {
        //         // alert("exists")
        //         setIsLoading(false);
        //     }
        // });
        db.collection("nv_loan")
            .where("loan_id", "==", params.id)
            .onSnapshot((snapshot) => {
                if (snapshot.empty) {
                    navigate("/error");
                    return;
                }

                // Always take the first matching doc
                const docData = snapshot.docs[0].data();
                const docId = snapshot.docs[0].id;

                setPersonalData(docData);
                setUid(docId);
                setRepaymentHistory(docData.payment_history || []); // ✅ correct place

                setIsLoading(false);
            });

        setSubmit({ id: '', document_status: personalData.document_status, verification_status: personalData.verification_status, nbfc_status: personalData.nbfc_status, penny_check_status: personalData.document_status, penny_check_status: personalData.godrej_status, loan_disbursement_status: personalData.loan_disbursement_status, status: personalData.status, updated_date: new Date() })



    }, []);

    const openModalShow = () => {
        // alert("ooo")
        window.openModelshow();
    }

    const changeStatus = (data, id) => {
        setEdit(true)
        setEditID(id)
        // setSubmit({ id: id, image: data.image, name: data.name, expert: data.expert, phone_no: data.phone_no, description: data.description, type: data.type, start_date_time: moment(data.start_date_time.toDate().toISOString()).format("YYYY-MM-DDThh:mm"), end_date_time: moment(data.end_date_time.toDate().toISOString()).format("YYYY-MM-DDThh:mm"), created_date: new Date() });
        setRepay({ loan_amount: data.loan_amount, loan_id: data.loan_id, loan_disbursement_date: data.loan_disbursement_date, emi_date: moment(data.emi_date.toDate().toISOString()).format("YYYY-MM-DDThh:mm"), amount: data.amount, payment_link: data.payment_link, paid_on: data.paid_on, status: data.status, })
    }

    const initialFormStateFeedback = { id: '', document_status: '', verification_status: '', nbfc_status: '', penny_check_status: '', godrej_status: '', loan_disbursement_status: '', status: '', updated_date: new Date() }
    const [submit, setSubmit] = useState(initialFormStateFeedback)
    const [name, setName] = useState("")

    const initialFormStateRepayment = { loan_amount: '', loan_id: "", loan_disbursement_date: new Date(), emi_date: '', amount: '', payment_link: '', paid_on: '', status: '', }
    // const [repay, setRepay] = useState(initialFormStateRepayment)
    const [repay, setRepay] = useState({});


    // const handleChangeRepay = (e) => {
    //     const { id, value } = e.target
    //     setRepay({ ...repay, [id]: value })
    //     console.log(e.target.value)
    // }

    const timeSlot = (msg) => {
        db.collection("time_slot").doc(slotsID[0]?.id).delete().then(() => {
            console.log('Deleted Successfully');
        })
        db.collection("time_slot").add({ 'time_slot': selectedSlots, 'type': 'video_call', 'phone': params.id, 'updated_date': new Date(), 'selected_date': selectedDate, 'selected_time': "" }).then(() => {
            console.log("user added");
            openModalNew();
            db.collection("loan_logs").add({ 'name': "Done", 'type': 'Time Slot Allocated', 'message': `Time Slot Allocated To User`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Time Slot Allocated for verification. Please check");
        })
    }

    const [views, setViews] = useState('remarks');

    const view = () => {
        console.log(views)
        if (views === "remarks") {
            setViews("logs")
        }
    }

    const viewR = () => {
        if (views === "logs") {
            setViews("remarks")
        }
    }

    // CollectionReference appNotification =
    // FirebaseFirestore.instance.collection('app_notification');

    const notifyApp = (msg) => {
        // Call the user's CollectionReference to add a new user
        db.collection("app_notification").add({ 'message': msg, 'link': "UnderReviewPage", 'status': "0", "uid": personalData.uid, 'created_date': new Date() }).then(() => {
            console.log("user added");
        })
    }



    const handleChange1 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'document_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Document Verification', 'message': `Document verification rejected :- ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })

            notifyApp(msg = "Your Document verification is rejected.");

        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'document_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Document Verification', 'message': "Document verified successfully", 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    notifyApp(msg = "Your Document verified successfully.");
                    Swal.fire('Updated!', '', 'success')
                }
            })

        } else {
            db.collection("loan").doc(uid).update({ 'document_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
        }




        //  else if (name === 'verification_status') {
        //     Swal.fire(name)
        //     db.collection("loan").doc(uid).update({ 'verification_status': parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })

        // } else if (name === 'nbfc_status') {
        //     // Swal.fire(name)
        //     db.collection("loan").doc(uid).update({ 'nbfc_status': parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })

        // }
        // else if (name === 'penny_check_status') {
        //     db.collection("loan").doc(uid).update({ 'penny_check_status': parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })

        // }
        // else if (name === 'godrej_status') {
        //     db.collection("loan").doc(uid).update({ 'godrej_status': parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })

        // }
        // else if (name === 'loan_disbursement_status') {
        //     db.collection("loan").doc(uid).update({ 'loan_disbursement_status': parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })
        // }

        // if (!text) {
        // Swal.fire(name)
        //     db.collection("loan").doc(uid).update({ document_status: parseInt(e.target.value), 'message': text, 'updated_date': new Date() }).then(() => {
        //         console.log("user added");
        //     })
        // }
    }

    const handleChange2 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'verification_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Video Call Verification', 'message': `Video call verification rejected : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Your video call verification is rejected.");
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'verification_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Video Call Verification', 'message': `Video call verified successfully`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    db.collection("time_slot").doc(slotsID[0].id).delete().then(() => {
                        console.log('Deleted Successfully');
                    })
                    notifyApp(msg = "Your video call verified successfully");
                    Swal.fire('Updated!', '', 'success')
                }
            })

            // setSelectedSlots([])

        } else if (e.target.value == "3") {
            changeStatus()
        }
        else {
            db.collection("loan").doc(uid).update({ 'verification_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
        }



    }

    const handleChange3 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'nbfc_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Physical Verification', 'message': `Physical verification rejected : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Your physical verification is rejected");
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'nbfc_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Physical Verification', 'message': 'Physical verification done', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    notifyApp(msg = "Your physical verification is done");
                    Swal.fire('Updated!', '', 'success')
                }
            })

        } else {
            db.collection("loan").doc(uid).update({ 'nbfc_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                console.log("user added");
            })
        }

    }




    const handleChange4 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'penny_check_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Penny Check Verification', 'message': `Penny check verification rejected : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Your Penny check verification is rejected");
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'penny_check_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        // console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Penny Check Verification', 'message': 'Penny Check verified successfully', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    notifyApp(msg = "Your Penny check is verified successfully");
                    Swal.fire('Updated!', '', 'success')
                }
            })

        } else {
            db.collection("loan").doc(uid).update({ 'penny_check_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
        }

    }

    const handleChange5 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)

        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'godrej_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Bank Verification', 'message': `Bank verification rejected : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Your Bank verification is rejected");
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'godrej_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        // console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Bank Verification', 'message': 'Bank verification successful', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    notifyApp(msg = "Your Bank verification is successful");
                    Swal.fire('Updated!', '', 'success')
                }
            })

            // setSelectedSlots([]);
        }
        else if (e.target.value == "3") {
            changeStatus()
        }
        else {
            db.collection("loan").doc(uid).update({ 'godrej_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
        }

    }

    const handleChange6 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'loan_disbursement_status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Loan Disbursement', 'message': `Loan Disbursement rejected : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
            notifyApp(msg = "Your Loan Disbursement is rejected");
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'loan_disbursement_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                        // console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Loan Disbursement', 'message': `Loan disbursed successfully`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    notifyApp(msg = "Congratulations Your Loan is disbursed  successfully");
                    Swal.fire('Updated!', '', 'success')
                }
            })

        } else {
            db.collection("loan").doc(uid).update({ 'loan_disbursement_status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date() }).then(() => {
                // console.log("user added");
            })
        }
    }

    const holdApplication = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You can revert this later!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Hold it!'
        }).then((result) => {
            if (result.isConfirmed) {
                db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': "Application is on hold!", 'error_message': "Your loan application is temporarily on hold due to the unavailability of funds. Please rest assured that your application remains a priority, and we anticipate processing it within the next 90 days once the necessary funds become available.\n\nWe genuinely value your patience during this period. Thank you for your interest in our loan scheme", 'updated_date': new Date() }).then(() => {
                    // console.log("user added");
                })
                db.collection("loan_logs").add({ 'name': "Hold", 'type': 'Loan Track', 'message': 'Application is on hold', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                    console.log("data added");
                })
            }
        })

    }


    const releaseApplication = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Release it!'
        }).then((result) => {
            if (result.isConfirmed) {
                db.collection("loan").doc(uid).update({ 'status': 0, 'error_message': "Application Released", 'updated_date': new Date() }).then(() => {
                    // console.log("user added");
                })
                db.collection("loan_logs").add({ 'name': "Released", 'type': 'Loan Track', 'message': 'Application is Released', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                    console.log("data added");
                })
            }
        })
    }


    const handleChange7 = async (e) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        // alert(e.target.name)
        setName(e.target.name)
        if (e.target.value == "2") {
            const { value: text } = await Swal.fire({
                input: 'textarea',
                inputLabel: 'Message',
                inputPlaceholder: 'Type your message here...',
                inputAttributes: {
                    'aria-label': 'Type your message here'
                },
                showCancelButton: true
            })
            // Swal.fire(name)
            db.collection("loan").doc(uid).update({ 'status': parseInt(e.target.value), 'error_message': text, 'updated_date': new Date(), 'loan_disbursement_date': new Date() }).then(() => {
                // console.log("user added");
            })
            db.collection("loan_logs").add({ 'name': "Rejected", 'type': 'Loan Track', 'message': `Loan Track Not Completed : ${text}`, 'updated_date': new Date(), 'phone': params.id }).then(() => {
                console.log("data added");
            })
        } else if (e.target.value == "1") {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, update it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    db.collection("loan").doc(uid).update({ 'status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date(), 'loan_disbursement_date': new Date() }).then(() => {
                        // console.log("user added");
                    })
                    db.collection("loan_logs").add({ 'name': "Done", 'type': 'Loan Track', 'message': 'Loan Track Completed', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                        console.log("data added");
                    })
                    Swal.fire('Updated!', '', 'success')
                }
            })

        } else {
            db.collection("loan").doc(uid).update({ 'status': parseInt(e.target.value), 'error_message': "", 'updated_date': new Date(), 'loan_disbursement_date': new Date() }).then(() => {
                // console.log("user added");
            })
        }
    }



    // const handleChange8 = async (e) => {
    //     const { value: text } = await Swal.fire({
    //         input: 'textarea',
    //         inputLabel: 'Message',
    //         inputPlaceholder: 'Type your message here...',
    //         inputAttributes: {
    //             'aria-label': 'Type your message here'
    //         },
    //         showCancelButton: true
    //     });

    //     const newRemark = {
    //         text: text,
    //         updated_date: new Date()
    //     };

    //     // Check if 'text' is not empty (length greater than 0)
    //     if (text.trim() !== '') {
    //         // Perform your action here when text is not empty
    //         // console.log('Text is not empty:', text);
    //         db.collection("loan_extra_data").doc(uid).update({ 'remark': arrayUnion(newRemark) }).then(() => {
    //             console.log("added");
    //         })
    //         // Replace the 'console.log' with the action you want to take.
    //     } else {
    //         // Handle the case when 'text' is empty
    //         console.log('Text is empty');
    //         // You can also provide feedback to the user or perform a different action here.
    //     }
    // }


    // const finalReject = async () => {

    //     const { value: formValues } = await Swal.fire({
    //         title: 'Update Details',
    //         html:
    //             // '<input id="swal-input" class="swal2-input" style="width: 80%;" placeholder="Title">' +
    //             '<select name="cars" id="types" style="width: 80%;" class="swal2-input"><option value="">Select Reason</option><option value="Financial condition not stable">Financial condition not stable</option> <option value="Existing loan">Existing loan</option> <option value="Low level of prepardeness">Low level of prepardeness</option> <option value="Incomplete documents">Incomplete documents</option> <option value="Incomplete images/videos">Incomplete images/videos</option> <option value="Others">Others</option></select>' +
    //             '<textarea id="swal-textarea" class="swal2-textarea" style="width: 80%;" placeholder="Type your description here...">',

    //         showCancelButton: true,
    //         confirmButtonText: 'Save',


    //         preConfirm: () => {
    //             // const inputField = document.getElementById('swal-input').value;
    //             const textareaField = document.getElementById('swal-textarea').value;
    //             const selectFiled = document.getElementById('types').value;

    //             if (selectFiled == "Financial condition not stable") {
    //                 alert("okay")
    //             }

    //             if (!selectFiled || !textareaField) {
    //                 Swal.showValidationMessage('Both fields are required');
    //             }

    //             return [textareaField, selectFiled];
    //         }

    //     });




    //     // if (formValues) {
    //     //     Swal.fire(JSON.stringify(formValues))
    //     // }

    //     const newRemark = {
    //         title: formValues[1],
    //         text: formValues[0],
    //         updated_date: new Date(),
    //         email: email,
    //         images: imgUrls,
    //     };

    //     // // Check if 'text' is not empty (length greater than 0)
    //     if (formValues[0].trim() !== '' && formValues[1].trim() !== '') {
    //         console.log("callinggggggggg")
    //         const docRef = db.collection("loan_extra_data").doc(uid);

    //         // Use .get() to check if the document exists
    //         docRef.get()
    //             .then((docSnapshot) => {
    //                 if (docSnapshot.exists) {
    //                     // Document exists, update it
    //                     docRef.update({
    //                         remark: arrayUnion(newRemark)
    //                     })
    //                         .then(() => {
    //                             console.log("Document updated");
    //                             setSelectedFiles([]);
    //                             setImageUrls([]);
    //                             setImgUrls([])
    //                             setFileKey(fileKey + 1);
    //                         })
    //                         .catch((error) => {
    //                             console.error("Error updating document: ", error);
    //                         });
    //                 } else {
    //                     // Document doesn't exist, create it
    //                     docRef.set({
    //                         remark: [newRemark],
    //                         phone: params.id,
    //                         image: imgUrls,
    //                         email: email,
    //                     })
    //                         .then(() => {
    //                             console.log("Document created");
    //                             setSelectedFiles([]);
    //                             setImageUrls([]);
    //                             setImgUrls([])
    //                             setFileKey(fileKey + 1);
    //                         })
    //                         .catch((error) => {
    //                             console.error("Error creating document: ", error);
    //                         });
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.error("Error checking document existence: ", error);
    //             });
    //         setLoading(false)
    //     } else {
    //         console.log("Text is empty. No update performed.");
    //     }
    // }

    // const handleChange111 = async (e) => {
    //     // alert(e.target.value);
    //     if (e.target.value === "Existing loan") {
    //         const { value: text } = await Swal.fire({
    //             input: "textarea",
    //             inputLabel: "Message",
    //             inputPlaceholder: "Type your message here...",
    //             inputAttributes: {
    //                 "aria-label": "Type your message here"
    //             },
    //             showCancelButton: true
    //         });
    //         if (text) {
    //             Swal.fire(text);
    //         }
    //     }
    // }
    const [rejectDropdown, setRejectDropdown] = useState('');
    const handleChange111 = async (e) => {
        setRejectDropdown(e.target.value);
        if (e.target.value === "Financial condition not stable") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant (RG) application has been rejected as it did not meet the criteria required for approval. During our assessment, we observed that your current financial situation might potentially affect your ability to repay the RG. We understand that financial circumstances can change, and a substantial increase in your income and financial stability could make your application more favorable for reconsideration. If you have any questions or further clarifications, please contact us.Thank you for your interest in our scheme. We appreciate your efforts and hope to see an improved application in the future.", // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You can revert this later!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Reject it!'
                }).then((result) => {
                    if (result.isConfirmed) {
                        db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                            // console.log("user added");
                        })
                        db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                            console.log("data added");
                        })
                    }
                })
            }

        } else if (e.target.value === "Existing loan") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant (RG) application has not been rejected as it did not meet the criteria required for approval. The decision was influenced by your existing loan obligation. The existing loan may impact your ability to repay the proposed RG. Understanding your current financial commitments is crucial for both parties to make informed decisions. We understand that financial situations can change, and we would be open to reevaluating your application in the future, should your circumstances improve. If you have any questions or further clarifications, please contact us.Thank you for your interest in our scheme. We appreciate your efforts and hope to see an improved application in the future.", // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        }
        else if (e.target.value === "Low level of prepardeness") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant (RG) application has not been rejected as it did not meet the criteria required for approval.\nDuring our assessment, we noticed that there was a lower level of preparedness and clarity regarding the utilization of the funds. To enhance your application's chances for reconsideration, we recommend conducting more detailed market research to strengthen your proposal.\nIf you have any questions or further clarifications, please contact us. Thank you for your interest in our scheme. We appreciate your efforts and hope to see an improved application in the future.", // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        }

        else if (e.target.value === "Not contactable") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant (RG) application has not been rejected as you are not contactable. Our team has made multiple attempts to conatct you  but unfortunately, we have been unable to reach you. If you have any questions or further clarifications, please contact us. Thank you for your interest in our scheme. We appreciate your efforts",
                // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        }

        else if (e.target.value === "Incomplete documents") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant appication has not rejected due to the absence of required documents. If you have any questions or further clarifications, please contact us. Thank you for your interest in our scheme. We appreciate your efforts hope to see an improved application in the future.", // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        } else if (e.target.value === "Incomplete images/videos") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "We regret to inform you that your returnable grant application has not rejected due to the absence of required images/videos. If you have any questions or further clarifications, please contact us. Thank you for your interest in our scheme. We appreciate your efforts hope to see an improved application in the future.",
                // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        } else if (e.target.value === "Others") {
            const { value: text } = await Swal.fire({
                input: "textarea",
                inputLabel: "Message",
                inputPlaceholder: "Type your message here...",
                inputValue: "", // Set your predefined value here
                inputAttributes: {
                    "aria-label": "Type your message here"
                },
                showCancelButton: true
            });

            if (text) {
                // Swal.fire(text);
                if (text) {
                    // Swal.fire(text);
                    Swal.fire({
                        title: 'Are you sure?',
                        text: "You can revert this later!",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, Reject it!'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            db.collection("loan").doc(uid).update({ 'status': 4, 'custom_msg_two': e.target.value, 'error_message': text, 'updated_date': new Date() }).then(() => {
                                // console.log("user added");
                            })
                            db.collection("loan_logs").add({ 'name': "Reject", 'type': 'Loan Track', 'message': 'Application is Rejected', 'updated_date': new Date(), 'phone': params.id }).then(() => {
                                console.log("data added");
                            })
                        }
                    })
                }
            }

        } else {

        }
    };



    const finalReject = async () => {
        // const { value: formValues } = await Swal.fire({
        //     title: 'Update Details',
        //     html:
        //         '<select name="cars" id="types" style="width: 80%;" class="swal2-input">' +
        //         '<option value="">Select Reason</option>' +
        //         '<option value="Financial condition not stable">Financial condition not stable</option>' +
        //         '<option value="Existing loan">Existing loan</option>' +
        //         '<option value="Low level of prepardeness">Low level of prepardeness</option>' +
        //         '<option value="Incomplete documents">Incomplete documents</option>' +
        //         '<option value="Incomplete images/videos">Incomplete images/videos</option>' +
        //         '<option value="Others">Others</option>' +
        //         '</select>' +
        //         '<textarea id="swal-textarea" class="swal2-textarea" style="width: 80%;" placeholder="Type your description here..."></textarea>',

        //     showCancelButton: true,
        //     confirmButtonText: 'Save',

        //     preConfirm: () => {
        //         const selectField = document.getElementById('types');

        //         if (!selectedValue) {
        //             Swal.showValidationMessage('This fields is required');
        //             return false; // Prevent closing the modal if validation fails
        //         }else{
        //             rejectMessage();
        //         }

        //         return [selectedValue];
        //     }
        // });
    };

    // const rejectMessage = async () => {
    //     const { value: text } = await Swal.fire({
    //         input: "textarea",
    //         inputLabel: "Message",
    //         inputPlaceholder: "Type your message here...",
    //         inputAttributes: {
    //             "aria-label": "Type your message here"
    //         },
    //         showCancelButton: true
    //     });
    //     if (text) {
    //         Swal.fire(text);
    //     }
    // }



    const handleChange8 = async () => {
        // const { value: text } = await Swal.fire({
        //     input: 'textarea',
        //     inputLabel: 'Message',
        //     inputPlaceholder: 'Type your message here...',
        //     inputAttributes: {
        //         'aria-label': 'Type your message here'
        //     },
        //     showCancelButton: true,
        //     confirmButtonText: 'Save',
        // });

        // const { value: text, value: inputField } = await Swal.fire({
        const { value: formValues } = await Swal.fire({
            title: 'Update Details',
            html:
                // '<input id="swal-input" class="swal2-input" style="width: 80%;" placeholder="Title">' +
                '<select name="cars" id="types" style="width: 80%;" class="swal2-input"><option value="">Select Feedback</option><option value="Documentation check feedback">Documentation check feedback</option> <option value="Video verification feedback">Video verification feedback</option> <option value="Physical verification feedback">Physical verification feedback</option> <option value="Penny check verification feedback">Penny check verification feedback</option> <option value="Bank verification check feedback">Bank verification check feedback</option> <option value="Any other feedback">Any other feedback</option> <option value="Overall feedback  ">Overall feedback  </option> </select>' +
                '<textarea id="swal-textarea" class="swal2-textarea" style="width: 80%;" placeholder="Type your remark here...">',

            showCancelButton: true,
            confirmButtonText: 'Save',
            preConfirm: () => {
                // const inputField = document.getElementById('swal-input').value;
                const textareaField = document.getElementById('swal-textarea').value;
                const selectFiled = document.getElementById('types').value;

                if (!selectFiled || !textareaField) {
                    Swal.showValidationMessage('Both fields are required');
                }

                return [textareaField, selectFiled];
            }
        });




        // if (formValues) {
        //     Swal.fire(JSON.stringify(formValues))
        // }

        const newRemark = {
            title: formValues[1],
            text: formValues[0],
            updated_date: new Date(),
            email: email,
            images: imgUrls,
            loan_id: params.id,
        };

        // // Check if 'text' is not empty (length greater than 0)
        if (formValues[0].trim() !== '' && formValues[1].trim() !== '') {
            console.log("callinggggggggg")
            const docRef = db.collection("loan_extra_data").doc(uid);

            // Use .get() to check if the document exists
            docRef.get()
                .then((docSnapshot) => {
                    if (docSnapshot.exists) {
                        // Document exists, update it
                        docRef.update({
                            remark: arrayUnion(newRemark)
                        })
                            .then(() => {
                                console.log("Document updated");
                                setSelectedFiles([]);
                                setImageUrls([]);
                                setImgUrls([])
                                setFileKey(fileKey + 1);
                            })
                            .catch((error) => {
                                console.error("Error updating document: ", error);
                            });
                    } else {
                        // Document doesn't exist, create it
                        docRef.set({
                            remark: [newRemark],
                            phone: params.id,
                            loan_id: params.id,
                            image: imgUrls,
                            email: email,
                        })
                            .then(() => {
                                console.log("Document created");
                                setSelectedFiles([]);
                                setImageUrls([]);
                                setImgUrls([])
                                setFileKey(fileKey + 1);
                            })
                            .catch((error) => {
                                console.error("Error creating document: ", error);
                            });
                    }
                })
                .catch((error) => {
                    console.error("Error checking document existence: ", error);
                });
            setLoading(false)
        } else {
            console.log("Text is empty. No update performed.");
        }
    }



    const addTransaction = async () => {
        try {
            const { value: formValues } = await Swal.fire({
                title: "Add Transaction ID",
                html: `
        <input id="swal-input" class="swal2-input" style="width: 80%;" placeholder="enter here..">
      `,
                showCancelButton: true,
                confirmButtonText: "Save",
                preConfirm: () => {
                    const inputField = document.getElementById("swal-input").value;

                    if (!inputField) {
                        Swal.showValidationMessage("Input required");
                    }

                    return inputField; // ✅ return just the string, not array
                },
            });

            // If user clicked "Cancel", formValues will be undefined
            if (formValues && formValues.trim() !== "") {
                console.log("Updating transaction...");

                const docRef = doc(db, "nv_loan", uid);
                await updateDoc(docRef, {
                    txn_id: formValues, // ✅ string value
                });

                createPaymentHistory();

                console.log("Transaction updated:", formValues);
                alert("Transaction ID added:", formValues)
            } else {
                console.log("No update performed (cancelled or empty).");
            }
        } catch (error) {
            console.error("Error updating transaction: ", error);
        } finally {
            setLoading(false); // ✅ always stop loading
        }
    };


    useEffect(() => {
        if (personalData.selected_emi_plan) {
            setFormDataFinal((prev) => ({
                ...prev,
                selectedEmiPlan: personalData.selected_emi_plan,
                approvedAmount: emiPlansList[personalData.selected_emi_plan],
                transactionId: personalData.txn_id || "",
            }));
        }
    }, [personalData.selected_emi_plan]);



    // const createPaymentHistory = async (id) => {
    //     try {
    //         const plan = emiPlans[id];
    //         if (!plan) {
    //             alert("No EMI plan selected");
    //             return;
    //         }

    //         // Extract amount & months
    //         const [amountStr, , monthsStr] = plan.split(" ");
    //         const amount = Number(amountStr.replace(/[₹,]/g, ""));
    //         const months = Number(monthsStr);

    //         // First EMI date = today + 60 days
    //         // const startDate = new Date(personalData.progress[0].date);
    //         console.log(personalData.progress[4].date)
    //         const startDate = moment(personalData.progress[4].date, "DD-MM-YYYY")
    //             .add(60, "days");
    //         console.log(startDate)
    //         startDate.setDate(startDate.getDate() + 60);




    //         const paymentHistory = [];

    //         for (let i = 0; i < months; i++) {
    //             const emiDate = moment(startDate).add(i, "months"); // safely add i months
    //             paymentHistory.push({
    //                 emi: i + 1,
    //                 amount: amount,
    //                 paid_amount: 0,
    //                 dueDate: emiDate.format("DD-MM-YYYY"), // properly formatted
    //                 status: "Pending",
    //                 paidDate: null,
    //                 isSuccess: false,
    //             });
    //         }

    //         const docRef = doc(db, "nv_loan", uid);
    //         await updateDoc(docRef, {
    //             payment_history: paymentHistory,
    //             nextEMIDate: paymentHistory[0].dueDate, // first EMI date
    //         });

    //         console.log("Payment history created ✅");
    //         alert("Payment history created successfully!");
    //     } catch (error) {
    //         console.error("Error creating payment history:", error);
    //         alert("Failed to create payment history!");
    //     }
    // };


    const createPaymentHistory = async (id) => {
        try {
            const plan = emiPlans[id];
            if (!plan) {
                alert("No EMI plan selected");
                return;
            }

            const [amountStr, , monthsStr] = plan.split(" ");
            const amount = Number(amountStr.replace(/[₹,]/g, ""));
            const months = Number(monthsStr);

            // Convert DD-MM-YYYY to moment date & add 60 days
            const startDate = moment(personalData.progress[4].date, "DD-MM-YYYY").add(60, "days");

            const paymentHistory = [];

            for (let i = 0; i < months; i++) {
                const emiDate = moment(startDate).add(i, "months"); // moment-safe month addition

                paymentHistory.push({
                    emi: i + 1,
                    amount: amount,
                    paid_amount: 0,
                    dueDate: emiDate.format("DD-MM-YYYY"), // e.g. 18-09-2023
                    status: "Pending",
                    paidDate: null,
                    isSuccess: false,
                });
            }

            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, {
                payment_history: paymentHistory,
                nextEMIDate: paymentHistory[0].dueDate,
            });

            alert("Payment history created successfully!");
            console.log("Payment history created");
        } catch (error) {
            console.error("Error creating payment history:", error);
            alert("Failed to create payment history!");
        }
    };




    const [progress, setProgress] = useState(0);
    const [selectedImages, setSelectedImages] = useState([]);

    const onSelectFileUpload = (e) => {
        e.preventDefault();
        const file = e.target[0].files[0];
        uploadFiles(file);

    }

    const uploadFiles = (files) => {
        // const promises = []
        // files.map((file) => {
        //     console.log('loop');

        //     const sotrageRef = ref(storage, `files/${file.name}`);

        //     const uploadTask = uploadBytesResumable(sotrageRef, file);
        //     promises.push(uploadTask)
        //     uploadTask.on(
        //         "state_changed",
        //         (snapshot) => {
        //             const prog = Math.round(
        //                 (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        //             );
        //             setProgress(prog);
        //         },
        //         (error) => console.log(error),
        //         async () => {
        //             await getDownloadURL(uploadTask.snapshot.ref).then((downloadURLs) => {
        //                 setURLs(prevState => [...prevState, downloadURLs])
        //                 console.log("File available at", downloadURLs);
        //             });
        //         }
        //     );


        // })
        // Promise.all(promises)
        //     .then(() => alert('All images uploaded'))
        //     .then(err => console.log(err))

    };

    const [imageUrls, setImageUrls] = useState([]);
    const [progresspercent, setProgresspercent] = useState(0);

    // const handleFileUpload = (e) => {
    //     const files = e.target.files;
    //     uploadImages(files);
    // };

    // const uploadImages = (files) => {
    //     const uploadPromises = [];

    //     for (const file of files) {

    //         const storageRef = ref(storage, `image_loans/${file.name}`);
    //         const uploadTask = uploadBytesResumable(storageRef, file);

    //         uploadTask.on("state_changed",
    //             (snapshot) => {
    //                 // Handle upload progress if needed
    //                 const progress =
    //                     Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
    //                 setProgresspercent(progress);
    //             }, (error) => {
    //                 console.error('Error uploading image:', error);
    //             }, () => {
    //                 // When the upload is complete, get the download URL
    //                 getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //                     setImageUrls((prevUrls) => [...prevUrls, downloadURL]);
    //                     console.log('Image URL:', downloadURL);
    //                 });
    //             });

    //         uploadPromises.push(uploadTask);
    //     }

    //     // Optionally, you can do something after all uploads are complete
    //     Promise.all(uploadPromises)
    //         .then(() => {
    //             console.log('All uploads completed');
    //         })
    //         .catch((error) => {
    //             console.error('Error during uploads:', error);
    //         });
    // };

    // console.log(selectedImages);
    // console.log(URLs);
    // const handleSubmit = () => { uploadFiles(images); }


    // const handleRepayment = async () => {

    //     db.collection("repayment_model").doc(personalData.loan_id).set({ 'all_payment_done': repay.all_payment_done, 'loan_amount': personalData.loan_amount, 'loan_id': personalData.loan_id, 'loan_disbursement_date': new Date(), 'emi_model': [{ 'emi_date_1': repay.emi_date_1, 'amount': repay.amount_1, 'payment_link': repay.payment_link_1, 'paid_on': repay.paid_on_1, 'status': repay.status_1 }, { 'emi_date_2': repay.emi_date_2, 'amount': repay.amount_2, 'payment_link': repay.payment_link_2, 'paid_on': repay.paid_on_2, 'status': repay.status_2 }, { 'emi_date_3': repay.emi_date_3, 'amount': repay.amount_3, 'payment_link': repay.payment_link_3, 'paid_on': repay.paid_on_3, 'status': repay.status_3 }], 'updated_date': new Date() }).then(() => {
    //         console.log("repayment_model");
    //     })
    //     // alert("pp")

    // }



    const handleChange32 = async (e, msg) => {
        const { id, value } = e.target
        setSubmit({ ...submit, [id]: value })
        if (e.target.value == "1") {
            // db.collection("business_card_request").doc(uid).update({ 'status': "1", 'updated_date': new Date() }).then(() => {
            //     console.log("user added");
            // })
            notifyApp(msg = 'Hi our executive tried getting in touch with you regarding loan request. Kindly call us back at 7428790444 ');
        } else {
            // db.collection("business_card_request").doc(uid).update({ 'status': "0", 'updated_date': new Date() }).then(() => {
            //     console.log("user added");
            // })
        }
    }

    // const Confirm = (id) => {
    //     db.collection("orderd_consumables_products").doc(id).update({ 'status': "Confirmed", 'updated_date': new Date() }).then(() => {
    //         console.log("user added");
    //     })
    // }

    // const message = async () => {
    //     alert("ok")
    //     const { value: text } = await Swal.fire({
    //         input: 'textarea',
    //         inputLabel: 'Message',
    //         inputPlaceholder: 'Type your message here...',
    //         inputAttributes: {
    //             'aria-label': 'Type your message here'
    //         },
    //         showCancelButton: true
    //     })

    //     if (text) {
    //         Swal.fire(text)
    //     }
    // }

    // const handleDeleteRemark = async (data) => {
    //     console.log(data);

    //     const indexToRemove = 0; // Replace with the index you want to remove

    //     const removedItem = data.splice(indexToRemove, 1);

    //     console.log('Removed Item:', removedItem);
    //     console.log('Updated Data:', data);

    //     try {
    //         await db.collection("loan_extra_data").doc("gE4fKRh7DL1ZPw4AwWKe").update({
    //             remark: db.FieldValue.arrayRemove(data), // Wrap the modified data in an array
    //         });

    //         // Update your local state or trigger a re-fetch of the data
    //         // You can use setState or useEffect to refresh your component
    //     } catch (error) {
    //         console.error('Error deleting data:', error);
    //     }

    //     // Now, the element at the specified index is removed from the 'data' array.
    // };

    // const handleDeleteRemark = async (data) => {
    //     console.log(data);

    //     const indexToRemove = 0; // Replace with the index you want to remove
    //     const removedItem = data[indexToRemove];

    //     console.log('Removed Item:', removedItem);
    //     console.log('Updated Data:', data);

    //     // try {
    //     //     await db.collection("loan_extra_data").doc("gE4fKRh7DL1ZPw4AwWKe").update({
    //     //         remark: arrayRemove(removedItem), // Remove the specific element
    //     //     });

    //     //     // Update your local state or trigger a re-fetch of the data
    //     //     // You can use setState or useEffect to refresh your component
    //     // } catch (error) {
    //     //     console.error('Error deleting data:', error);
    //     // }
    // };

    const [indexToRemove, setIndexToRemove] = useState(0);

    const getID = (id, index, data) => {
        // setIndexToRemove(index)
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                handleDeleteRemark(id, index, data)
            }
        })


    }

    const handleDeleteRemark = async (id, index, data) => {
        console.log(data);
        console.log(id);
        console.log(index);

        // const indexToRemove = 0; // Replace with the index you want to remove

        // Get the Firestore document reference
        const docRef = db.collection("loan_extra_data").doc(id);

        try {
            // Fetch the current data from Firestore
            const doc = await docRef.get();
            const existingData = doc.data();

            // Remove the specific element from the 'remark' array
            existingData.remark.splice(index, 1);

            // Update the modified data back to Firestore
            await docRef.update({ remark: existingData.remark });

            // Update your local state or trigger a re-fetch of the data
            // You can use setState or useEffect to refresh your component

        } catch (error) {
            console.error('Error deleting data:', error);
        }
    };


    const [selectedFiles, setSelectedFiles] = useState([]);

    const handleFileSelect = (e) => {
        const files = e.target.files;
        setSelectedFiles(files);
        // Create an array of URLs for image previews
        const previewUrls = Array.from(files).map(file => URL.createObjectURL(file));
        setImageUrls(previewUrls);
    };

    const handleUpload = () => {
        uploadImages(selectedFiles);
    };

    const [imgUrls, setImgUrls] = useState([]);
    const [loading, setLoading] = useState(false);


    const uploadImages = (files) => {
        if (files.length === 0) {
            handleChange8();
        } else {

            setLoading(true);
            const uploadPromises = [];

            for (const file of files) {

                const storageRef = ref(storage, `image_loans/${file.name}`);
                const uploadTask = uploadBytesResumable(storageRef, file);

                uploadTask.on("state_changed",
                    (snapshot) => {
                        // Handle upload progress if needed
                        const progress =
                            Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
                        setProgresspercent(progress);
                    }, (error) => {
                        console.error('Error uploading image:', error);
                    }, () => {
                        // When the upload is complete, get the download URL
                        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                            // setImageUrls((prevUrls) => [...prevUrls, downloadURL]);
                            imgUrls.push(downloadURL)
                            console.log('Image URL:', downloadURL);
                        });
                    });

                uploadPromises.push(uploadTask);
            }

            // Optionally, you can do something after all uploads are complete
            Promise.all(uploadPromises)
                .then(() => {
                    console.log('All uploads completed');
                    handleChange8();

                })
                .catch((error) => {
                    console.error('Error during uploads:', error);
                });
        }



    };

    const [activeTab, setActiveTab] = useState("basic");
    const [lightbox, setLightbox] = useState({ open: false, src: "", title: "" });

    // const data = loan ?? demoLoan; // fallback to demo

    const openLightbox = (src, title) => setLightbox({ open: true, src, title });
    const closeLightbox = () => setLightbox({ open: false, src: "", title: "" });


    const [repayment, setRepayment] = useState([]);

    const [editID, setEditID] = useState('');
    const [edit, setEdit] = useState(false);

    const isStepEnabled = (index) => {
        if (index === 0) return true;
        const prev = personalData.progress[index - 1];
        return prev && prev.status === "Done";
    };



    useEffect(() => {
        if (!personalData?.loan_id) return;

        const unsubscribe = db
            .collection("repayment_model")
            .where("loan_id", "==", personalData.loan_id)
            .onSnapshot((snapshot) => {
                setRepayment(
                    snapshot.docs.map((doc) => ({
                        id: doc.id,
                        data: doc.data(),
                    }))
                );
            });

        return () => unsubscribe(); // Clean up on unmount
    }, [personalData.loan_id]);


    // const handleChangeRepay = (e) => {
    //     const { id, value } = e.target;
    //     setRepay((prev) => ({ ...prev, [id]: value }));
    // };

    // const handleRepayment = async () => {
    //     if (!repay.amount || !repay.emi_date) {
    //         alert("Please fill the fields first.");
    //         return;
    //     }

    //     const defaultAmount = {
    //         1: "4000",
    //         2: "5000",
    //         3: "1000",
    //         4: "1250",
    //     };

    //     const amount = defaultAmount[personalData.selected_emi_plan] || "2500";

    //     await db.collection("repayment_model").add({
    //         loan_amount: personalData.loanAmount,
    //         loan_id: personalData.loan_id,
    //         loan_disbursement_date: personalData.loan_disbursement_date,
    //         emi_date: new Date(repay.emi_date),
    //         amount,
    //         payment_link: repay.payment_link,
    //         paid_on: repay.paid_on,
    //         status: repay.status,
    //         updated_date: new Date(),
    //     });

    //     setRepay({
    //         loan_amount: '',
    //         loan_id: '',
    //         loan_disbursement_date: new Date(),
    //         emi_date: '',
    //         amount: '',
    //         payment_link: '',
    //         paid_on: '',
    //         status: '',
    //     });
    // };

    const handleRepayment = async () => {
        console.log(personalData.loanAmount);
        console.log(personalData.loan_id);
        console.log(personalData.loan_disbursement_date);
        console.log(new Date(repay.emi_date));
        console.log(personalData.selected_emi_plan);
        console.log(personalData.payment_link);

        const EMIdate = new Date(repay.emi_date);

        // format as DD-MM-YYYY
        const formattedDate = EMIdate
            .toLocaleDateString("en-GB") // gives DD/MM/YYYY
            .replace(/\//g, "-");        // replace / with -

        if (repay.emi_date == "") {
            alert("Please fill the fields first.!")
        } else {
            db.collection("repayment_model").add({ 'loan_amount': personalData.loanAmount, 'loan_id': personalData.loan_id, 'loan_disbursement_date': personalData.loan_disbursement_date, 'emi_date': new Date(repay.emi_date), 'amount': emiPlansList[personalData.selected_emi_plan], 'payment_link': repay.payment_link, 'paid_on': repay.paid_on, 'status': repay.status, 'updated_date': new Date() }).then(() => {
                console.log("repayment_model");
                setRepay({ loan_amount: '', loan_id: "", loan_disbursement_date: new Date(), emi_date: '', amount: '', payment_link: '', paid_on: '', status: '', })
            })

            const docRef = doc(db, "nv_loan", uid);
            await updateDoc(docRef, {
                nextEMIDate: formattedDate,
            });
        }

        // alert("pp")
    }


    const handleChangeRepay = (e) => {
        const { id, value } = e.target;
        setRepay((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const EMIdate = new Date(repay.emi_date);
    const PO = new Date();

    // format as DD-MM-YYYY
    const formattedDate = EMIdate
        .toLocaleDateString("en-GB") // gives DD/MM/YYYY
        .replace(/\//g, "-");

    // format as DD-MM-YYYY
    const formattedDatePaid = PO
        .toLocaleDateString("en-GB") // gives DD/MM/YYYY
        .replace(/\//g, "-");

    const updateRepayment = async () => {
        await db.collection("repayment_model").doc(editID).update({
            loan_amount: personalData.loanAmount,
            loan_id: personalData.loan_id,
            loan_disbursement_date: personalData.loan_disbursement_date,
            emi_date: new Date(repay.emi_date),
            amount: repay.amount,
            payment_link: repay.status === "1" ? '' : repay.payment_link,
            paid_on: new Date(),
            status: repay.status,
            updated_date: new Date(),
        });

        if (repay.status == 1) {
            const docRef = doc(db, "nv_loan", uid);

            await updateDoc(docRef, {
                payment_history: [
                    {
                        emi: 1,
                        amount: Number(repay.amount),   // ✅ converted to integer
                        dueDate: formattedDate,
                        status: "Done",
                        paidDate: formattedDatePaid,
                        isSuccess: true,
                    },
                ],
                nextEMIDate: null,
            });
        }




        setRepay({
            loan_amount: '',
            loan_id: '',
            loan_disbursement_date: new Date(),
            emi_date: '',
            amount: '',
            payment_link: '',
            paid_on: '',
            status: '',
        });

        setEdit(false);
    };



    // const handleUpdateRepayment = async () => {
    //     try {
    //         const updatedHistory = [...repaymentHistory];
    //         updatedHistory[editIndex] = {
    //             ...updatedHistory[editIndex],
    //             ...repay,
    //             emi_date: repay.emi_date ? new Date(repay.emi_date) : null,
    //             updated_date: new Date(),
    //         };

    //         const docRef = doc(db, "nv_loan", uid);
    //         await updateDoc(docRef, { payment_history: updatedHistory });

    //         setRepaymentHistory(updatedHistory); // update UI immediately
    //         setRepay({});
    //         setEditIndex(null);
    //         alert("Repayment updated ✅");
    //     } catch (error) {
    //         console.error("Error updating repayment:", error);
    //     }
    // };


    // const handleUpdateRepayment = async () => {
    //     try {
    //         const updatedHistory = [...repaymentHistory];

    //         updatedHistory[editIndex] = {
    //             ...updatedHistory[editIndex], // keep untouched fields
    //             amount: Number(repay.amount) || 0,
    //             dueDate: repay.dueDate || updatedHistory[editIndex].dueDate,
    //             emi: Number(repay.emi) || updatedHistory[editIndex].emi,
    //             isSuccess: true,
    //             paidDate: "",
    //             paid_amount: Number(repay.paid_amount) || 0,
    //             status: "Done",
    //         };

    //         const docRef = doc(db, "nv_loan", uid);
    //         await updateDoc(docRef, { payment_history: updatedHistory });

    //         setRepaymentHistory(updatedHistory); // update UI immediately
    //         setRepay({});
    //         setEditIndex(null);
    //         alert("Repayment updated ✅");
    //     } catch (error) {
    //         console.error("Error updating repayment:", error);
    //     }
    // };

    // const handleUpdateRepayment = async () => {
    //     if (repay.paid_amount > 1) {
    //         try {
    //             const updatedHistory = [...repaymentHistory];

    //             // Format date helper
    //             const formatDate = (date) => {
    //                 if (!date) return "";
    //                 const d = new Date(date);

    //                 // Date part
    //                 const day = String(d.getDate()).padStart(2, "0");
    //                 const month = String(d.getMonth() + 1).padStart(2, "0");
    //                 const year = d.getFullYear();

    //                 // Time part with AM/PM
    //                 const hours = d.getHours();
    //                 const minutes = String(d.getMinutes()).padStart(2, "0");
    //                 const ampm = hours >= 12 ? "PM" : "AM";
    //                 const formattedHours = hours % 12 || 12; // convert 0 -> 12

    //                 // return `${day}-${month}-${year} ${formattedHours}:${minutes} ${ampm}`;
    //                 return `${day}-${month}-${year}`;
    //             };

    //             updatedHistory[editIndex] = {
    //                 ...updatedHistory[editIndex], // keep untouched fields
    //                 amount: Number(repay.amount) || 0,
    //                 dueDate: repay.dueDate || updatedHistory[editIndex].dueDate,
    //                 emi: Number(repay.emi) || updatedHistory[editIndex].emi,
    //                 isSuccess: true,
    //                 paidDate: formatDate(new Date()), // ✅ current date in DD-MM-YYYY
    //                 paid_amount: Number(repay.paid_amount) || 0,
    //                 status: "Done",
    //             };

    //             const docRef = doc(db, "nv_loan", uid);
    //             await updateDoc(docRef, { payment_history: updatedHistory });

    //             setRepaymentHistory(updatedHistory); // update UI immediately
    //             setRepay({});
    //             repay.paid_amount = null;


    //             setEditIndex(null);
    //             alert("Repayment updated ✅");
    //         } catch (error) {
    //             console.error("Error updating repayment:", error);
    //         }
    //     } else {
    //         alert("paid amount can not be 0")
    //     }


    // };


    const handleUpdateRepayment = async () => {
        if (repay.paid_amount > 1) {
            try {
                const updatedHistory = [...repaymentHistory];

                // Format date helper
                const formatDate = (date) => {
                    if (!date) return "";
                    const d = new Date(date);
                    const day = String(d.getDate()).padStart(2, "0");
                    const month = String(d.getMonth() + 1).padStart(2, "0");
                    const year = d.getFullYear();
                    return `${day}-${month}-${year}`;
                };

                updatedHistory[editIndex] = {
                    ...updatedHistory[editIndex],
                    amount: Number(repay.amount) || 0,
                    dueDate: repay.dueDate || updatedHistory[editIndex].dueDate,
                    emi: Number(repay.emi) || updatedHistory[editIndex].emi,
                    isSuccess: true,
                    paidDate: repay.paid_on
                        ? formatDate(repay.paid_on)
                        : formatDate(new Date()), // fallback to now
                    paid_amount: Number(repay.paid_amount) || 0,
                    status: "Done",
                    payment_link: repay.payment_link || "",
                };

                const docRef = doc(db, "nv_loan", uid);
                await updateDoc(docRef, { payment_history: updatedHistory });

                setRepaymentHistory(updatedHistory);
                setRepay({});
                setEditIndex(null);
                alert("Repayment updated ✅");
            } catch (error) {
                console.error("Error updating repayment:", error);
            }
        } else {
            alert("Paid amount cannot be 0");
        }
    };





    const changeStatusR = (data, id) => {
        setEdit(true);
        setEditID(id);
        setRepay({
            loan_amount: data.loan_amount,
            loan_id: data.loan_id,
            loan_disbursement_date: data.loan_disbursement_date,
            emi_date: Moment(data.emi_date.toDate()).format("YYYY-MM-DDThh:mm"),
            amount: data.amount,
            payment_link: data.payment_link,
            paid_on: data.paid_on,
            status: data.status,
        });
    };

    const repaymentCompleted = async () => {
        Swal.fire({
            title: 'Do you want to complete this repayment status?',
            showDenyButton: true,
            confirmButtonText: 'Complete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                db.collection("nv_loan").doc(uid).update({ 'repayment_completed': 1, 'updated_date': new Date() }).then(() => {
                    Swal.fire('Completed!', '', 'success')
                })

            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        })

        // alert("pp")
    }




    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <>

            <SideMenu onToggle={setSidebarOpen} />

            <div class="p-5" style={styles.page}>
                {/* Header */}
                <header style={styles.header}>
                    <div style={styles.headerLeft}>
                        <img
                            src={personalData.Passportsize_Photo || demoAvatar}
                            alt={personalData.fullName || "Applicant"}
                            style={styles.avatar}
                            onError={(e) => (e.currentTarget.src = demoAvatar)}
                        />
                        <div>
                            <h2 style={styles.name}>{personalData.fullName || "-"}</h2>
                            <div style={styles.subMeta}>
                                <span style={styles.badge}>Loan ID: {personalData.loan_id || "-"}</span>
                                <span style={{ marginLeft: 8, color: "#64748b" }}>
                                    Status: <strong>{demoLoan.loan?.status || "—"}</strong>
                                </span>
                                <Link to={`/user_loan_details_modify/${personalData.username}`} ><p style={{
                                    paddingTop: "5px",
                                    fontWeight: "700",
                                    color: "crimson", cursor: "pointer"
                                }}>Edit Details</p></Link>
                            </div>

                        </div>
                    </div>

                    <div style={styles.headerRight}>
                        <div style={{ textAlign: "right", color: "#64748b", fontSize: 12 }}>Created</div>
                        <div style={{ fontWeight: 600 }}>{personalData.created_date?.toDate().toLocaleString() || "-"}</div>

                    </div>
                </header >

                {/* Tabs */}
                < div style={styles.tabs} >
                    <TabButton active={activeTab === "basic"} onClick={() => setActiveTab("basic")}>
                        Basic Details
                    </TabButton>
                    <TabButton active={activeTab === "business"} onClick={() => setActiveTab("business")}>
                        Business Details
                    </TabButton>
                    <TabButton active={activeTab === "bank"} onClick={() => setActiveTab("bank")}>
                        Bank Details
                    </TabButton>
                    <TabButton active={activeTab === "loan"} onClick={() => setActiveTab("loan")}>
                        Loan Details
                    </TabButton>
                    <TabButton active={activeTab === "docs"} onClick={() => setActiveTab("docs")}>
                        Documents
                    </TabButton>
                    <TabButton active={activeTab === "remarks"} onClick={() => setActiveTab("remarks")}>
                        Remarks & Track Log
                    </TabButton>
                    <TabButton active={activeTab === "verification"} onClick={() => setActiveTab("verification")}>
                        Verification
                    </TabButton>
                    <TabButton active={activeTab === "repayment"} onClick={() => setActiveTab("repayment")}>
                        Disbursement & Repayment
                    </TabButton>
                </div >

                {/* Panels */}
                {
                    activeTab === "basic" && (
                        <SectionCard title="Basic Details">
                            <div style={styles.grid}>
                                <RowItem label="Name" value={personalData.fullName} />
                                <RowItem label="Phone" value={personalData.username} />
                                <RowItem label="DOB" value={personalData.dob} />
                                <RowItem label="Marital Status" value={personalData.maritalStatus} />
                                <RowItem label="Gender" value={personalData.gender} />
                                <RowItem label="Father's Name" value={personalData.fatherName} />

                                <RowItem label="Mother's Name" value={personalData.motherName} />
                                <RowItem label="State" value={personalData.state} />
                                <RowItem label="City" value={personalData.city} />
                                <RowItem label="Pincode" value={personalData.pincode} />
                                <RowItem label="Address" value={personalData.address} />
                                <RowItem label="Highest Education" value={personalData.education} />
                                <RowItem label="Aadhar Number" value={personalData.aadhar_number} />
                                <RowItem label="PAN Number" value={personalData.pan_number} />
                            </div>
                        </SectionCard>
                    )
                }

                {
                    activeTab === "business" && (
                        <SectionCard title="Business Details">
                            {/* <div style={styles.grid}>
                            <RowItem label="Business Name" value={demoLoan.business?.name} />
                            <RowItem label="Type" value={demoLoan.business?.type} />
                            <RowItem label="Industry" value={demoLoan.business?.industry} />
                            <RowItem label="Years in Business" value={demoLoan.business?.years} />
                            <RowItem label="Monthly Revenue" value={demoLoan.business?.monthlyRevenue} />
                            <RowItem label="GSTIN" value={demoLoan.business?.gstin} />
                            <RowItem label="Address" value={demoLoan.business?.address} />
                        </div> */}
                            <div style={styles.grid}>
                                <RowItem label="Business Type (Primary Occupation)" value={personalData.businessType} />
                                <RowItem label="Business Name" value={personalData.businessName} />
                                <RowItem label="Secondary Occupation" value={personalData.secondary_occupation} />
                                {/* Ownership Type is commented out in the original */}
                                <RowItem label="Working Since" value={personalData.businessEstablishedYear} />
                                <RowItem label="Monthly Income" value={personalData.monthlyIncome} />
                                <RowItem label="Monthly Household Income" value={personalData.secondary_occupation} />
                            </div>

                        </SectionCard>
                    )
                }

                {
                    activeTab === "bank" && (
                        <SectionCard title="Bank Details">
                            <div style={styles.grid}>
                                <RowItem label="Account No." value={personalData.bankAccountNumber} />
                                <RowItem label="Account Holder" value={personalData.fullName} />
                                <RowItem label="Bank" value={personalData.bankName} />
                                <RowItem label="IFSC" value={personalData.ifscCode} />
                                {/* Branch is commented out in original */}
                                <RowItem label="UPI ID (Optional)" value={personalData.uipId} />
                            </div>
                        </SectionCard>
                    )
                }

                {
                    activeTab === "loan" && (
                        <SectionCard title="Loan Details">
                            <div style={styles.grid}>
                                <RowItem label="Amount" value={personalData.loanAmount} />
                                <RowItem label="Have you taken any loan in the past?" value={personalData.takenPastLoan} />
                                <RowItem label="Purpose" value={personalData.whyNeedGrant} />
                                <RowItem label="Specify" value={personalData.nameOfEqupiment} />
                                <RowItem label="Estimated" value={personalData.estimatedPrice} />
                                <RowItem label="Repayment Model" value={emiPlans[personalData.selected_emi_plan] || "N/A"} />
                                <RowItem label="How did you get to know about this loan" value={personalData.aboutThisLoan} />
                            </div>

                        </SectionCard>
                    )
                }

                {
                    activeTab === "docs" && (
                        // <SectionCard title="Documents">
                        //     <div style={styles.docsGrid}>
                        //         <DocThumb
                        //             src={demoLoan.documents?.aadharFront || placeholderDoc}
                        //             title="Aadhar Front"
                        //             onClick={openLightbox}
                        //         />
                        //         <DocThumb
                        //             src={demoLoan.documents?.aadharBack || placeholderDoc}
                        //             title="Aadhar Back"
                        //             onClick={openLightbox}
                        //         />
                        //         <DocThumb
                        //             src={demoLoan.documents?.pan || placeholderDoc}
                        //             title="PAN"
                        //             onClick={openLightbox}
                        //         />
                        //         <DocThumb
                        //             src={demoLoan.documents?.passbook || placeholderDoc}
                        //             title="Passbook"
                        //             onClick={openLightbox}
                        //         />
                        //         <DocThumb
                        //             src={demoLoan.documents?.passport || placeholderDoc}
                        //             title="Passport"
                        //             onClick={openLightbox}
                        //         />
                        //     </div>
                        //     <div style={{ color: "#64748b", fontSize: 12, marginTop: 8 }}>
                        //         Click any document to view larger.
                        //     </div>
                        // </SectionCard>
                        <SectionCard title="Documents">
                            <div style={styles.docsGrid}>
                                <DocThumb
                                    src={personalData.Aadhar_Front || placeholderDoc}
                                    title="Aadhar Front"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Aadhar_Back || placeholderDoc}
                                    title="Aadhar Back"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Pan_Card || placeholderDoc}
                                    title="PAN Card"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Passbook_Front || placeholderDoc}
                                    title="Passbook"
                                    onClick={openLightbox}
                                />
                                <DocThumbPDF
                                    src={personalData.Bank_Statement || placeholderDoc}
                                    title="Bank Statement"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Passportsize_Photo || placeholderDoc}
                                    title="Applicant Photo"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Building_Front_Image || placeholderDoc}
                                    title="Shop Front"
                                    onClick={openLightbox}
                                />
                                <DocThumb
                                    src={personalData.Building_Interior_Image || placeholderDoc}
                                    title="Shop Interior"
                                    onClick={openLightbox}
                                />
                                <DocThumbVideo
                                    src={personalData.Business_Video || placeholderDoc}
                                    title="Business Video"
                                    onClick={openLightbox}
                                />
                            </div>
                            <div style={{ color: "#64748b", fontSize: 12, marginTop: 8 }}>
                                Click any document to view larger.
                            </div>
                        </SectionCard>

                    )
                }




                {/* {activeTab === "disbursement" && (
                    <SectionCard title="Disbursement">
                        <div style={styles.grid}>

                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>#</th>
                                            <th>Label</th>
                                            <th>Is Complete</th>
                                            <th>Status</th>
                                            <th>Message</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {personalData?.progress?.length > 0 ? (
                                            personalData.progress.map((step, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{step.label || "N/A"}</td>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            value={step.isComplete ? "true" : "false"}
                                                            onChange={(e) => handleIsCompleteChange(index, e.target.value, personalData.fullName, personalData.username)}
                                                        >
                                                            <option value="true">✅ True</option>
                                                            <option value="false">❌ False</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            value={step.status}
                                                            onChange={(e) => handleStatusChange(index, e.target.value, personalData.fullName, personalData.username)}
                                                        >
                                                            <option value="Pending">Pending</option>
                                                            <option value="Done">Done</option>
                                                            <option value="In Progress">In Progress</option>
                                                            <option value="Rejected">Rejected</option>
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={step.message || ""}
                                                            onChange={(e) => handleMessageChange(index, e.target.value)}
                                                        />
                                                    </td>
                                                    <td>
                                                        <td>
                                                            {step.date && moment(step.date, "DD-MM-YYYY").isValid()
                                                                ? moment(step.date, "DD-MM-YYYY").format("DD-MM-YYYY")
                                                                : "N/A"}
                                                        </td>

                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center">No progress data available</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div >

                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th>Final Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <select
                                                    className="form-control"
                                                    value={personalData.final_status || "Pending"}
                                                    onChange={(e) => handleFinalStatusChange(e.target.value, personalData.username, personalData.fullName, personalData.loanAmount)}
                                                >
                                                    <option value="Pending">Pending</option>
                                                    <option value="Disbursed">Disbursed</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </SectionCard>
                )} */}


                {
                    activeTab === "verification" && (
                        <SectionCard title="Verification">
                            {/* {personalData?.progress?.length > 0 ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                                {personalData.progress.map((step, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            border: "1px solid #ddd",
                                            borderRadius: 8,
                                            padding: 16,
                                            backgroundColor: "#Verification",
                                        }}
                                    >
                                        <div style={{ fontWeight: "bold", fontSize: 16, marginBottom: 8 }}>
                                            Step {index + 1}: {step.label || "N/A"}
                                        </div>

                                        <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                                            <div style={{ flex: 1, minWidth: 150 }}>
                                                <label style={{ fontSize: 13 }}>Is Complete</label>
                                                <select
                                                    className="form-control"
                                                    value={step.isComplete ? "true" : "false"}
                                                    onChange={(e) =>
                                                        handleIsCompleteChange(index, e.target.value, personalData.fullName, personalData.username)
                                                    }
                                                >
                                                    <option value="true">✅ True</option>
                                                    <option value="false">❌ False</option>
                                                </select>
                                            </div>

                                            <div style={{ flex: 1, minWidth: 150 }}>
                                                <label style={{ fontSize: 13 }}>Status</label>
                                                <select
                                                    className="form-control"
                                                    value={step.status}
                                                    onChange={(e) =>
                                                        handleStatusChange(index, e.target.value, personalData.fullName, personalData.username)

                                                    }
                                                    disabled={step.status == "Done" ? true : false}
                                                    style={{ padding: "1px" }}
                                                >
                                                    <option value="Pending">Pending</option>
                                                    <option value="Done">✅ Done</option>
                                                    <option value="In Progress">In Progress</option>
                                                    <option value="Rejected">Rejected</option>
                                                </select>
                                            </div>

                                            <div style={{ flex: 2, minWidth: 200 }}>
                                                <label style={{ fontSize: 13 }}>Message</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={step.message || ""}
                                                    onChange={(e) => handleMessageChange(index, e.target.value)}
                                                    readOnly={step.status == "Done" ? true : false}
                                                />
                                            </div>

                                            {index != 4 && (<div style={{ flex: 1, minWidth: 150 }}>
                                                <label style={{ fontSize: 13 }}>Date</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={
                                                        step.date && moment(step.date, "DD-MM-YYYY").isValid()
                                                            ? moment(step.date, "DD-MM-YYYY").format("DD-MM-YYYY")
                                                            : "N/A"
                                                    }
                                                    readOnly
                                                />
                                            </div>

                                            )}
                                            {index === 4 && (
                                                <div style={{ flex: 1, minWidth: 150 }}>
                                                    <label style={{ fontSize: 13 }}>Date</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={
                                                            moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                : ""
                                                        }
                                                        onChange={(e) => handleDateChangeDisbursement(index, e.target.value)}
                                                        disabled={personalData.final_status == "Disbursed" ? true : false}
                                                    />
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div style={{ color: "#64748b", textAlign: "center" }}>No progress data available</div>
                        )} */}


                            {personalData?.progress?.length > 0 ? (
                                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                                    {personalData.progress.map((step, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                border: "1px solid #ddd",
                                                borderRadius: 8,
                                                padding: 16,
                                                backgroundColor: "#Verification",
                                            }}
                                        >
                                            <div style={{ fontWeight: "bold", fontSize: 16, marginBottom: 8 }}>
                                                Step {index + 1}: {step.label || "N/A"}
                                            </div>

                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                                                <div style={{ flex: 1, minWidth: 150 }}>
                                                    <label style={{ fontSize: 13 }}>Status</label>
                                                    <select
                                                        className="form-control"
                                                        value={step.status}
                                                        onChange={async (e) => {
                                                            const newValue = e.target.value;
                                                            // handleStatusChange(index, e.target.value, personalData.fullName, personalData.username)
                                                            // Swal.fire({
                                                            //     title: "Do you want to save the changes, without messages?",

                                                            //     showCancelButton: true,
                                                            //     confirmButtonText: "Save",
                                                            // }).then((result) => {
                                                            //     if (result.isConfirmed) {
                                                            //         // Swal.fire("Saved!", "", "success");
                                                            //         handleStatusChange(index, newValue, personalData.fullName, personalData.username)
                                                            //     } else if (result.isDenied) {
                                                            //         Swal.fire("Changes are not saved", "", "info");
                                                            //     }
                                                            // });
                                                            const { value: text } = await Swal.fire({
                                                                input: "textarea",
                                                                inputLabel: "Message",
                                                                inputPlaceholder: "Type your message here...",
                                                                inputAttributes: {
                                                                    "aria-label": "Type your message here"
                                                                },
                                                                showCancelButton: true
                                                            });
                                                            if (text) {
                                                                // Swal.fire(text);
                                                                handleMessageChange(index, text)
                                                                handleStatusChange(index, newValue, personalData.fullName, personalData.username)
                                                            } else {
                                                                handleStatusChange(index, newValue, personalData.fullName, personalData.username)
                                                            }
                                                        }

                                                        }
                                                        disabled={step.status === "Done" || !isStepEnabled(index)}  // only enabled if previous is done
                                                        style={{ padding: "1px", paddingLeft: "5px" }}
                                                    >
                                                        <option value="Pending">Pending</option>
                                                        <option value="Done">✅ Completed</option>
                                                        <option value="In Progress">In Progress</option>
                                                        <option value="Rejected">Rejected</option>
                                                    </select>
                                                </div>

                                                <div style={{ flex: 2, minWidth: 200 }}>
                                                    <label style={{ fontSize: 13 }}>Message</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={step.message || ""}
                                                        onChange={(e) => handleMessageChange(index, e.target.value)}
                                                        // readOnly={step.status === "Done" || !isStepEnabled(index)}
                                                        readOnly
                                                    />
                                                </div>

                                                {index !== 4 && (
                                                    <div style={{ flex: 1, minWidth: 150 }}>
                                                        <label style={{ fontSize: 13 }}>Date</label>
                                                        {/* <input
                                                            type="date"
                                                            className="form-control"
                                                            // value={
                                                            //     step.date && moment(step.date, "DD-MM-YYYY").isValid()
                                                            //         ? moment(step.date, "DD-MM-YYYY").format("DD-MM-YYYY")
                                                            //         : "N/A"
                                                            // }
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            onChange={(e) => handleMessageChangeDate(index, e.target.value)}
                                                            
                                                        // readOnly
                                                        /> */}
                                                        {/* <input
                                                            type="date"
                                                            className="form-control"
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            disabled={moment(step.date, "DD-MM-YYYY", true).isValid()}
                                                            onChange={(e) => handleMessageChangeDate(index, e.target.value)}
                                                        /> */}

                                                        {/* <input
                                                            type="date"
                                                            className="form-control"
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            disabled={moment(step.date, "DD-MM-YYYY", true).isValid()}
                                                            // onChange={(e) => handleMessageChangeDate(index, e.target.value)}
                                                            onClick={handleMessageChangeDateNew(index)}
                                                        /> */}

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            disabled={moment(step.date, "DD-MM-YYYY", true).isValid()}
                                                            onClick={() => handleMessageChangeDateNew(index)}

                                                        />



                                                    </div>
                                                )}

                                                {index === 4 && (
                                                    <div style={{ flex: 1, minWidth: 150 }}>
                                                        <label style={{ fontSize: 13 }}>Date</label>
                                                        {/* <input
                                                            type="date"
                                                            className="form-control"
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            onChange={(e) => handleDateChangeDisbursement(index, e.target.value)}
                                                            // disabled={personalData.final_status == "Disbursed" ? true : false}
                                                            disabled={moment(step.date, "DD-MM-YYYY", true).isValid()}
                                                        /> */}

                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={
                                                                moment(step.date, "DD-MM-YYYY", true).isValid()
                                                                    ? moment(step.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                                                                    : ""
                                                            }
                                                            disabled={moment(step.date, "DD-MM-YYYY", true).isValid()}
                                                            onClick={() => handleDateChangeDisbursement(index)}

                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div style={{ color: "#64748b", textAlign: "center" }}>No progress data available</div>
                            )}


                            <div className="row mb-3 mt-4 p-2">
                                <h3 style={{ fontWeight: "bold" }}>Loan Approval Final Status</h3>
                                <form onSubmit={handleSubmitFinal} className="row g-3 mt-3">
                                    <div className="col-md-3">
                                        <label>Select EMI Plan</label>
                                        <select
                                            name="selectedEmiPlan"
                                            className="form-control"
                                            value={formDataFinal.selectedEmiPlan}
                                            onChange={handleChangeFinalDetails}
                                            required
                                            disabled={personalData.final_status == "Disbursed" ? true : false}
                                            style={{ padding: "1px", paddingLeft: "5px" }}
                                        >
                                            <option value="">Select a Plan</option>
                                            {Object.entries(emiPlans).map(([key, label]) => (
                                                <option key={key} value={key}>
                                                    {label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>Loan Approved Amount</label>
                                        <input
                                            type="number"
                                            name="approvedAmount"
                                            className="form-control"
                                            value={formDataFinal.approvedAmount}
                                            onChange={handleChangeFinalDetails}
                                            required
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label>Transaction ID</label>
                                        <input
                                            type="text"
                                            name="transactionId"
                                            className="form-control"
                                            value={formDataFinal.transactionId}
                                            onChange={handleChangeFinalDetails}
                                            required
                                            disabled={personalData.final_status == "Disbursed" ? true : false}
                                        />
                                    </div>
                                    {/* 
                                <div className="col-md-3">
                                    <label>Moratorium Period (months)</label>
                                    <input
                                        type="number"
                                        name="moratoriumPeriod"
                                        className="form-control"
                                        value={formDataFinal.moratoriumPeriod}
                                        onChange={handleChangeFinalDetails}
                                        required
                                    />
                                </div> */}


                                    {/* <div className="col-md-3">
                                    <label>No. of Installments</label>
                                    <input
                                        type="number"
                                        name="numberOfInstallments"
                                        className="form-control"
                                        value={formDataFinal.numberOfInstallments}
                                        onChange={handleChangeFinalDetails}
                                        required
                                    />
                                </div> */}

                                    {/* Submit Button aligned right */}
                                    {personalData.final_status == "Disbursed" ? <></> : <>
                                        <div className="col-12 d-flex justify-content-end mt-3">
                                            <button type="submit" className="btn btn-primary">
                                                Submit
                                            </button>
                                        </div>
                                    </>}
                                </form>
                            </div>


                            {/* Final Status Dropdown */}
                            {/* <div
                            style={{
                                marginTop: 32,
                                borderTop: "1px solid #eee",
                                paddingTop: 24,
                            }}
                        >
                            <div style={{ fontWeight: 600, marginBottom: 8 }}>Final Status</div>

                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <select
                                    className="form-control"
                                    style={{ maxWidth: 300, height: "3rem" }}
                                    value={personalData.final_status || "Pending"}
                                    disabled={personalData.final_status == "Disbursed" ? true : false}
                                    onChange={(e) =>
                                        handleFinalStatusChange(
                                            e.target.value,
                                            personalData.username,
                                            personalData.fullName,
                                            personalData.loanAmount
                                        )
                                    }
                                >
                                    <option value="Pending">Pending</option>
                                    <option value="Disbursed">Disbursed</option>
                                </select>

                                {!personalData.txn_id ? <button
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#009688",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                    }}
                                    onClick={addTransaction}
                                >
                                    Add Transaction ID
                                </button> : ""}

                                <button
                                    style={{
                                        padding: "8px 16px",
                                        backgroundColor: "#009688",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "6px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                    }}
                                    onClick={addTransaction}
                                >
                                    Add Transaction ID
                                </button>
                            </div>
                        </div> */}



                        </SectionCard>
                    )
                }

                {
                    activeTab === "repayment" && (
                        <SectionCard title="Repayment Details">
                            {/* 1. Loan Summary */}
                            {/* <div style={{ marginBottom: 24, }}> */}
                            <div style={styles.grid} class="mb-8">
                                <RowItem label="Loan ID" value={personalData.loan_id} />
                                <RowItem label="Transaction ID" value={personalData.txn_id} />
                                <RowItem label="Total Amount" value={personalData.loanAmount} />
                                <RowItem label="Repayment Model" value={emiPlans[personalData.selected_emi_plan] || "Not Selected"} />
                                <RowItem
                                    label="Disbursement Date"
                                    value={
                                        personalData.loan_disbursement_date
                                            ? moment(personalData.loan_disbursement_date.toDate()).format("MM/DD/YY, h:mm a")
                                            : ""
                                    }
                                />


                            </div>

                            {/* 2. Repayment History */}
                            {/* <div style={{ overflowX: "auto", marginBottom: 24 }}>
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>EMI Date</th>
                                        <th>Amount</th>
                                        <th>Payment Link</th>
                                        <th>Updated On</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {repayment.length ? (
                                        repayment.map(({ id, data }) => (
                                            <tr
                                                key={id}
                                                style={{
                                                    backgroundColor: data.status === "1" ? "#e6ffed" : "transparent",
                                                }}
                                            >
                                                <td>
                                                    {data.emi_date
                                                        ? moment(data.emi_date.toDate()).format("MM/DD/YY, h:mm a")
                                                        : "—"}
                                                </td>
                                                <td>{data.amount}</td>
                                                <td>
                                                    {data.payment_link ? (
                                                        <a href={data.payment_link} target="_blank" rel="noopener noreferrer">
                                                            Link
                                                        </a>
                                                    ) : (
                                                        "—"
                                                    )}
                                                </td>
                                                <td>
                                                    {data.updated_date
                                                        ? moment(data.updated_date.toDate()).format("MM/DD/YY, h:mm a")
                                                        : "—"}
                                                </td>
                                                <td>{data.status === "1" ? "Paid" : "UnPaid"}</td>
                                                <td>
                                                    {data.status !== "1" ? (
                                                        <button
                                                            className="btn btn-sm btn-outline-info"
                                                            onClick={() => changeStatus(data, id)}
                                                        >
                                                            Edit
                                                        </button>
                                                    ) : (
                                                        <span className="text-success">Done</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center text-muted">
                                                No repayment entries found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> */}

                            <div style={{ overflowX: "auto", marginBottom: 24 }}>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>EMI #</th>
                                            <th>EMI Date</th>
                                            <th>EMI Amount</th>
                                            <th>Paid Amount</th>
                                            <th>Paid On</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {repaymentHistory.length ? (
                                            repaymentHistory.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        backgroundColor: item.status === "Done" ? "#e6ffed" : "transparent",
                                                    }}
                                                >
                                                    <td>{item.emi}</td>
                                                    <td>{item.dueDate || "—"}</td>
                                                    <td>{item.amount}</td>
                                                    <td>{item.paid_amount}</td>
                                                    <td>{item.paidDate}</td>
                                                    <td>{item.status == "Done" ? "Completed" : item.status}</td>
                                                    <td>
                                                        {item.status !== "Done" ? (
                                                            <button
                                                                className="btn btn-sm btn-outline-info"
                                                                onClick={() => {
                                                                    console.log(item)
                                                                    setRepay(item);       // fill form with clicked row
                                                                    setEditIndex(index);  // store index of the entry

                                                                }}
                                                            >
                                                                Update
                                                            </button>
                                                        ) : (
                                                            <span className="text-success">Done</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-muted">
                                                    No repayment entries found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>


                            {/* 3. Create or Update EMI */}
                            {/* {personalData.repayment_completed === 0 && (
                                <>
                                    <h6 className="mb-3">Update EMI Entry</h6>
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <label>EMI Date</label>
                                            <input
                                                type="text"
                                                id="amount"
                                                className="form-control"
                                                disabled
                                                value={repay.dueDate}


                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label>EMI Amount</label>
                                            <input
                                                type="text"
                                                id="amount"
                                                className="form-control"
                                                disabled
                                                value={repay.amount}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label>Paid Amount</label>
                                            <input
                                                type="text"
                                                id="paid_amount"
                                                className="form-control"
                                                value={repay.paid_amount}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label>Payment Link</label>
                                            <input
                                                type="text"
                                                id="payment_link"
                                                className="form-control"
                                                value={repay.payment_link}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Status</label>
                                            <select
                                                id="status"
                                                className="form-control"
                                                value={repay.status}
                                                onChange={handleChangeRepay}
                                            >
                                                <option value="">Select status</option>
                                                <option value="0">UnPaid</option>
                                                <option value="1">Paid</option>
                                            </select>
                                        </div>
                                    </div>
                                </>
                            )} */}


                            {personalData.repayment_completed === 0 && (
                                <>
                                    <h6 className="mb-3">Update EMI Entry</h6>
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <label>EMI Date (text format)</label>
                                            <input
                                                type="text"
                                                id="dueDate"
                                                className="form-control"
                                                value={repay.dueDate || ""}
                                                onChange={handleChangeRepay}
                                                placeholder="e.g. 12-11-2025"
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label>EMI Amount</label>
                                            <input
                                                type="text"
                                                id="amount"
                                                className="form-control"
                                                value={repay.amount || ""}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label>Paid Amount</label>
                                            <input
                                                type="text"
                                                id="paid_amount"
                                                className="form-control"
                                                value={repay.paid_amount || ""}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label>Paid On (optional)</label>
                                            <input
                                                type="date"
                                                id="paid_on"
                                                className="form-control"
                                                value={repay.paid_on || ""}
                                                onChange={handleChangeRepay}
                                            />
                                        </div>
                                        {/* <div className="col-md-4">
                                            <label>Payment Link</label>
                                            <input
                                                type="text"
                                                id="payment_link"
                                                className="form-control"
                                                value={repay.payment_link || ""}
                                                onChange={handleChangeRepay}
                                            />
                                        </div> */}
                                        {/* <div className="col-md-3">
                                            <label>Status</label>
                                            <select
                                                id="status"
                                                className="form-control"
                                                value={repay.status || ""}
                                                onChange={handleChangeRepay}
                                            >
                                                <option value="">Select status</option>
                                                <option value="0">UnPaid</option>
                                                <option value="1">Paid</option>
                                            </select>
                                        </div> */}
                                    </div>
                                </>
                            )}


                            {/* 4. Action Buttons */}
                            <div className="d-flex gap-3">
                                {personalData.repayment_completed === 0 ? (
                                    <>

                                        <button className="btn btn-info" onClick={repaymentCompleted}>
                                            Complete Repayment
                                        </button>

                                        {editIndex != null ? (
                                            // <button className="btn btn-warning" onClick={updateRepayment}>
                                            //     Update
                                            // </button>
                                            <button
                                                className="btn btn-success"
                                                onClick={handleUpdateRepayment}
                                                disabled={editIndex === null}
                                            >
                                                Save Changes
                                            </button>

                                        ) : ""}
                                    </>
                                ) : (
                                    <button className="btn btn-secondary" disabled>
                                        Repayment Completed
                                    </button>
                                )}
                            </div>
                        </SectionCard>
                    )
                }



                {/* {activeTab === "remarks" && (
                    <SectionCard title="Remarks & Track Log">
                        <div style={{ marginBottom: 16 }}>
                            <RowItem label="Latest Remark" value={demoLoan.remarks?.latest} />
                        </div>
                        <div style={styles.timeline}>
                            {data.remarks?.log?.length ? (
                                data.remarks.log.map((r, idx) => (
                                    <div key={idx} style={styles.timelineItem}>
                                        <div style={styles.timelineDot} />
                                        <div style={styles.timelineContent}>
                                            <div style={{ fontWeight: 600 }}>{r.title}</div>
                                            <div style={{ color: "#64748b", fontSize: 12 }}>{r.when}</div>
                                            <div style={{ marginTop: 6 }}>{r.note}</div>
                                            {r.by && (
                                                <div style={{ marginTop: 4, color: "#64748b", fontSize: 12 }}>
                                                    By: {r.by}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div style={{ color: "#64748b" }}>No track log yet.</div>
                            )}
                        </div>
                    </SectionCard>
                )} */}



                {
                    activeTab === "remarks" && (
                        <SectionCard title="Remarks & Track Log">
                            {/* Add Remarks Button */}
                            <div style={{ display: "flex", justifyContent: "end" }}>
                                <button
                                    style={{
                                        marginRight: "4rem",
                                        marginLeft: "2rem",
                                        color: views === "remarks" ? "#009688" : "black",
                                        fontWeight: "700",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleChange8}
                                >
                                    Add Remarks
                                </button>
                            </div>

                            {/* Toggle View */}
                            <div style={{ marginBottom: "4rem" }}>
                                <span
                                    style={{
                                        marginRight: "4rem",
                                        marginLeft: "2rem",
                                        color: views === "remarks" ? "#009688" : "black",
                                        fontWeight: "700",
                                        cursor: "pointer",
                                    }}
                                    onClick={viewR}
                                >
                                    View Remarks
                                </span>
                                <span
                                    onClick={view}
                                    style={{
                                        color: views === "logs" ? "#009688" : "black",
                                        fontWeight: "700",
                                        cursor: "pointer",
                                    }}
                                >
                                    View Track Logs
                                </span>
                            </div>

                            {views === "remarks" ? (
                                <div className="p-2">
                                    <div className="experience">
                                        {remarks?.length === 0 ? (
                                            <p style={{ color: "black" }}>No Remarks added</p>
                                        ) : (
                                            remarks?.map(({ id, data }, index) => {
                                                const sortedRemarksWithOriginalIndex = data?.remark?.map((remark, remarkIndex) => ({
                                                    ...remark,
                                                    originalIndex: remarkIndex,
                                                }));

                                                const sortedRemarks = sortedRemarksWithOriginalIndex?.sort(
                                                    (a, b) => b.updated_date.toDate() - a.updated_date.toDate()
                                                );

                                                return (
                                                    <React.Fragment key={id}>
                                                        {sortedRemarks?.map((e, i) => {
                                                            const textWithLineBreaks = e.text.replace(/\n/g, "<br>");
                                                            return (
                                                                <div className="item" key={`${id}-${i}`}>
                                                                    <h5 className="company-name" style={{ fontSize: "1rem" }}>
                                                                        {e.title}
                                                                    </h5>
                                                                    <span style={{ color: "#e91e63" }}>({e.email})</span>
                                                                    <div className="job-info">
                                                                        <div>{moment(e.updated_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</div>
                                                                    </div>
                                                                    <div style={{ paddingTop: "1rem" }}>
                                                                        <ul className="fa-ul">
                                                                            <li>
                                                                                <i className="fa-li fa fa-hand-o-right"></i>
                                                                                <div
                                                                                    dangerouslySetInnerHTML={{
                                                                                        __html: textWithLineBreaks,
                                                                                    }}
                                                                                />
                                                                            </li>
                                                                        </ul>
                                                                    </div>
                                                                    <div style={{ marginRight: "10px" }}>
                                                                        {e?.images?.map((image, imgIdx) => (
                                                                            <a href={image} target="_blank" key={imgIdx}>
                                                                                <img
                                                                                    style={{ marginRight: "2rem" }}
                                                                                    src={image}
                                                                                    alt="img"
                                                                                    width="50"
                                                                                    height="50"
                                                                                />
                                                                            </a>
                                                                        ))}
                                                                    </div>
                                                                    <img
                                                                        src="/images/icon_delete.png"
                                                                        className="me-3"
                                                                        onClick={() => getID(id, e.originalIndex, data.remark)}
                                                                        style={{ height: "2rem", cursor: "pointer" }}
                                                                        alt="delete"
                                                                    />
                                                                </div>
                                                            );
                                                        })}
                                                    </React.Fragment>
                                                );
                                            })
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="p-2">
                                    <div className="experience">
                                        {logs?.length ? (
                                            logs.map(({ id, data }, index) => (
                                                <div className="item" key={index}>
                                                    <h5 className="company-name" style={{ fontSize: "1rem" }}>
                                                        {data.type}
                                                    </h5>
                                                    <div className="job-info">
                                                        <div className="title" style={{ color: data.name === "Done" ? null : "red" }}>
                                                            {data.name}
                                                        </div>
                                                        <div>{moment(data.updated_date.toDate().toISOString()).format("MM/DD/YY, h:mm a")}</div>
                                                    </div>
                                                    <div>
                                                        <ul className="fa-ul">
                                                            <li>
                                                                <i className="fa-li fa fa-hand-o-right"></i>
                                                                {data.message}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ color: "#64748b" }}>No track log yet.</div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </SectionCard>
                    )
                }



                {/* Lightbox */}
                {
                    lightbox.open && (
                        <div style={styles.lightbox} onClick={closeLightbox}>
                            <div style={styles.lightboxInner} onClick={(e) => e.stopPropagation()}>
                                <img
                                    src={lightbox.src}
                                    alt={lightbox.title}
                                    style={{ maxWidth: "90vw", maxHeight: "80vh", borderRadius: 8 }}
                                />
                                <div style={{ marginTop: 8, color: "#e2e8f0" }}>{lightbox.title}</div>
                                <button style={styles.closeBtn} onClick={closeLightbox}>
                                    ✕
                                </button>
                            </div>
                        </div>
                    )
                }
            </div >

        </>

    );

}

export default UsersLoanDetails;



/* ---------------- Styles ---------------- */
const styles = {
    page: { padding: 5, background: "#fff", margin: "5px" },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16,
        padding: 16,
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        marginBottom: 16,
        background: "rgb(248, 250, 252)",
    },
    headerLeft: { display: "flex", alignItems: "center", gap: 16 },
    headerRight: {},
    avatar: { width: 64, height: 64, borderRadius: "50%", objectFit: "cover", border: "1px solid #e5e7eb" },
    name: { margin: 0, fontSize: 22, fontWeight: 700, color: "#0f172a" },
    subMeta: { marginTop: 4, fontSize: 14 },
    badge: {
        background: "#eef2ff",
        color: "#3730a3",
        border: "1px solid #c7d2fe",
        padding: "2px 8px",
        borderRadius: 999,
        fontWeight: 600,
    },
    tabs: {
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        borderBottom: "1px solid #e5e7eb",
        paddingBottom: 8,
        marginBottom: 16,
    },
    tabBtn: {
        border: "1px solid #e5e7eb",
        background: "#fff",
        padding: "8px 12px",
        borderRadius: 8,
        cursor: "pointer",
        fontWeight: 600,
        color: "#334155",
    },
    tabBtnActive: {
        background: "#0ea5e9",
        borderColor: "#0ea5e9",
        color: "#fff",
    },
    card: {
        border: "1px solid #e5e7eb",
        borderRadius: 10,
        overflow: "hidden",
        marginBottom: 16,
        background: "#fff",
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        padding: "12px 16px",
        borderBottom: "1px solid #e5e7eb",
        background: "#f8fafc",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: 12,
    },
    rowItem: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        border: "1px solid #f1f5f9",
        borderRadius: 8,
        padding: 12,
        background: "#fff",
    },
    label: { fontSize: 12, color: "#64748b", textTransform: "uppercase", letterSpacing: 0.3 },
    value: { fontSize: 15, color: "#0f172a", fontWeight: 600 },

    docsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: 12,
    },
    docThumb: {
        position: "relative",
        height: 160,
        borderRadius: 10,
        overflow: "hidden",
        border: "1px solid #e5e7eb",
        cursor: "pointer",
        background: "#f8fafc",
    },
    docCaption: {
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        background: "linear-gradient(transparent, rgba(0,0,0,0.6))",
        color: "#fff",
        fontSize: 12,
        padding: "6px 8px",
    },

    timeline: {
        position: "relative",
        marginTop: 8,
        paddingLeft: 18,
    },
    timelineItem: {
        position: "relative",
        marginBottom: 16,
        borderLeft: "2px solid #e5e7eb",
        paddingLeft: 12,
    },
    timelineDot: {
        position: "absolute",
        left: -6,
        top: 4,
        width: 10,
        height: 10,
        background: "#0ea5e9",
        borderRadius: "50%",
    },
    timelineContent: {
        background: "#f8fafc",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: 10,
    },

    lightbox: {
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.75)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 16,
    },
    lightboxInner: { textAlign: "center", position: "relative" },
    closeBtn: {
        position: "absolute",
        top: -8,
        right: -8,
        border: "none",
        background: "#ef4444",
        color: "#fff",
        borderRadius: "50%",
        width: 32,
        height: 32,
        cursor: "pointer",
        fontSize: 16,
        fontWeight: 700,
    },
};

/* --------- Demo data (remove in production) --------- */
const demoAvatar =
    "https://cdn-icons-png.flaticon.com/512/10337/10337609.png";

const placeholderDoc =
    "https://images.unsplash.com/photo-1520975890026-c65b6b07f26c?w=600&q=60&auto=format&fit=crop";

const demoLoan = {
    profile: {
        image: demoAvatar,
        name: "Aarav Sharma",
        phone: "+91 98765 43210",
        email: "aarav@example.com",
        dob: "1993-05-22",
        gender: "Male",
    },
    address: {
        line1: "221B, Baker Street",
        state: "Maharashtra",
        city: "Mumbai",
        pincode: "400001",
    },
    business: {
        name: "Sharma Traders",
        type: "Sole Proprietorship",
        industry: "Retail",
        years: "5",
        monthlyRevenue: "₹3,50,000",
        gstin: "27ABCDE1234F1Z5",
        address: "Andheri East, Mumbai",
    },
    bank: {
        holder: "Aarav Sharma",
        accountNo: "XXXXXX4521",
        ifsc: "HDFC0000123",
        bankName: "HDFC Bank",
        branch: "Andheri East",
        type: "Savings",
    },
    loan: {
        loanId: "LN-2025-000123",
        product: "Business Loan",
        amount: "₹7,50,000",
        tenure: "24",
        interestRate: "13.5%",
        purpose: "Working Capital",
        status: "In Review",
        disbursedOn: "-",
    },
    documents: {
        aadharFront: "https://www.hindustantimes.com/ht-img/img/2024/06/13/550x309/g25d8ae251a260d4a26714d65e211e978cbd81b0026081a8a7_1717141512454_1718272054234.png",
        aadharBack: "https://5.imimg.com/data5/FL/GY/YP/SELLER-13089154/aadhar-pre-printed-card-500x500.jpg",
        pan: "https://www.whytecroftford.com/wp-content/uploads/2024/05/PAN-CARD-min.png",
        passbook: "https://www.financialexpress.com/wp-content/uploads/2024/07/SBI-passbook.jpg",
        passport: "https://t4.ftcdn.net/jpg/01/67/07/95/360_F_167079543_Rk1lsNYGxsfbJHXqM4y7voo3cmm1DcpV.jpg",
    },
    remarks: {
        latest: "KYC verified. Income docs pending.",
        log: [
            { title: "Application Submitted", when: "2025-08-02 10:32", note: "User submitted application.", by: "Portal" },
            { title: "KYC Verified", when: "2025-08-03 16:10", note: "Aadhaar & PAN verified.", by: "Ops Team" },
            { title: "Income Docs Requested", when: "2025-08-04 11:55", note: "Requested last 6 months bank statement.", by: "RM - Priya" },
        ],
    },
    meta: {
        createdAt: "2025-08-02 10:30",
    },
};